<template>
<div>
  <div
    class="contentblock board_layout box-click"
    :class="checkLockOwn()"
    :data-block-id="bdata.paperBlockId"
  >
    <ContentBlockCreatorInfo
      v-show="!emptyBlock"
      :bdata ="bdata"
      :blockModDate="blockModDate"
      :blockRegDate="blockRegDate"
      :blockModUserName="blockModUserName"
      :blockRegUserName="blockRegUserName">
    </ContentBlockCreatorInfo>
    <!-- [블럭 잠금 표시부분] -->
    <div class="editor">
      <div class="name">
        {{ defaultLanguage.indexOf('ko') != -1 ? bdata.blockLockName : 
            bdata.blockLockNameEn != null ? bdata.blockLockNameEn : bdata.blockLockName }}</div>
      <div class="lock">{{$i18nUtil.trans("message.ContentBlockTypeContent.001","잠김")}}</div>
    </div>
    <!-- /[블럭 잠금 표시부분] -->
    <div class="eidtbox-ty1 align_top">
      <div class="row_box clear hover_box">
        <!-- [rowbox] -->
        <div class="hover_inner">
          <!-- [드래그 핸들] -->
          <!-- 보이는 드래그 핸들 -->
          <div class="move" :class="checkLockOwn() === OTPS().NOBODY ? '' : 'hidden'"></div>
          <!-- 실제 이벤트 드래그 핸들 -->
          <div class="block_handle" ref="dragHandle"
            :data-block-id="bdata.paperBlockId"
            :transfer-data="bdata.paperBlockId"
            @mousedown="dragBlockState(1)"
            @mouseup="dragBlockState(0)"
            @touchstart="dragBlockState(1)"
            @touchend="dragBlockState(0)">
            &nbsp;
          </div>
          <!-- /[드래그 핸들] -->
          <div>
            <!-- [에디터타입 블럭] -->
            <template v-if="editor && !loading">
              <editor-menu-bar ref="menubar"
                :editor="editor"
                v-slot="{ commands, isActive, focused }">
                <div class="menubar is-hidden"
                  :class="{ 'mock_table_bubble_menubar': focused && checkLockOwn() === OTPS().OWNER && isActive.table(), 'hidden': !isActive.table() }">
                  <!-- :class="{ 'is-focused': focused && checkLockOwn() === OTPS().OWNER && isActive.table(), 'hidden': !isActive.table() }" -->
                  <!-- <span class="table_menus">
                    <button class="menubar-button tb-add-btn1"
                      @mousedown="{ cancelBlur(commands.addRowBefore); }">
                      {{$i18nUtil.trans("message.ContentBlockTypeContent.004","상단행")}}
                    </button>
                    <button class="menubar-button tb-add-btn2"
                      @mousedown="{ cancelBlur(commands.addRowAfter); }">
                      {{$i18nUtil.trans("message.ContentBlockTypeContent.005","하단행")}}
                    </button>
                    <button class="menubar-button tb-add-btn3"
                      @mousedown="{ cancelBlur(commands.deleteRow); }">
                      {{$i18nUtil.trans("message.ContentBlockTypeContent.006","행삭제")}}
                    </button>
                    <div class="div"></div>
                    <button class="menubar-button tb-add-btn4"
                      @mousedown="{ cancelBlur(commands.addColumnBefore); }">
                      {{$i18nUtil.trans("message.ContentBlockTypeContent.007","좌측열")}}
                    </button>
                    <button class="menubar-button tb-add-btn5"
                      @mousedown="{ cancelBlur(commands.addColumnAfter); }">
                      {{$i18nUtil.trans("message.ContentBlockTypeContent.008","우측열")}}
                    </button>
                    <button class="menubar-button tb-add-btn6"
                      @mousedown="{ cancelBlur(commands.deleteColumn); }">
                      {{$i18nUtil.trans("message.ContentBlockTypeContent.009","열삭제")}}
                    </button>
                    <div class="div"></div>
                    <button class="menubar-button tb-add-btn7"
                      @mousedown="{ cancelBlur(commands.toggleCellMerge); }">
                      {{$i18nUtil.trans("message.ContentBlockTypeContent.010","셀병합")}}
                    </button>
                    <button class="menubar-button tb-add-btn9" 
                      slot="trigger" ref="tableColorPickerBtn" :class="{ 'is-active': isActive.span_element({ color: color }) }"
                      @mousemove="showColorPicker(1, tableBubbleMenu)"
                      @mouseout="showColorPicker(0, tableBubbleMenu)"
                    >
                      {{$i18nUtil.trans("message.ContentBlockTypeContent.014","셀배경")}}
                    </button>
                    <div ref="tableColorPickerBdy" 
                      class="hidden" 
                      @mousemove="showColorPicker(1, tableBubbleMenu)"
                      @mouseout="showColorPicker(0, tableBubbleMenu)"
                      style="position:absolute; left:365px;">
                      <div class="vue-swatches__container clear col-4" style="position:relative;">
                        <button class="tableColorPicker"
                          @click="setColorFromPicker($event, c, commands, tableBubbleMenu)"
                          v-for="(c, inx) in swatches"
                          :key="inx"
                          :class="'hw-table-cell-color-bg-' + inx + ' ' + (isSetColor(c) ? 'active' : '')">
                        </button>
                      </div>
                    </div>
                    <div class="div"></div>
                    <button class="menubar-button tb-add-btn10"
                      @mousedown="{ cancelBlur(markStyle, {isActive, commands, param: 'bold'}); }">
                      {{$i18nUtil.trans("message.ContentBlockTypeContent.015","볼드")}}
                    </button>
                    <button class="menubar-button tb-add-btn11"
                      @mousedown="{ cancelBlur(markStyle, {isActive, commands, param: 'italic'}); }"> 
                      {{$i18nUtil.trans("message.ContentBlockTypeContent.016","이탤릭")}}
                    </button>
                    <button class="menubar-button tb-add-btn12"
                      @mousedown="{ cancelBlur(markStyle, {isActive, commands, param: 'strike'}); }"> 
                      {{$i18nUtil.trans("message.ContentBlockTypeContent.017","취소선")}} 
                    </button>
                    <button class="menubar-button tb-add-btn13"
                      @mousedown="{ cancelBlur(markStyle, {isActive, commands, param: 'underline'}); }"> 
                      {{$i18nUtil.trans("message.ContentBlockTypeContent.018","언더라인")}} 
                    </button>
                    <div class="div"></div>
                    <button class="menubar-button tb-add-btn14"
                      @mousedown="{ cancelBlurBranch(commands.deleteTable, deleteBlock); }">
                      {{$i18nUtil.trans("message.ContentBlockTypeContent.011","표삭제")}}
                    </button>
                  </span> -->
                  <span class="hidden">
                    <button
                      class="menubar-button btn-add-bullet"
                      @click="commands.bullet_list">
                      UL
                    </button>
                    <button
                      class="menubar-button btn-add-number"
                      @click="commands.ordered_list">
                      OL
                    </button>
                  </span>
                </div>
              </editor-menu-bar>
              <!-- [editor bubble bar 영역] -->
              <editor-menu-bubble
                ref="menububble"
                :editor="editor"
                :keep-in-bounds="keepInBounds"
                v-slot="{ commands, isActive, menu }">
                <div class="menububble"
                  :class="{ 'is-active': menu.isActive && checkLockOwn() === OTPS().OWNER }"
                  :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`">
                  <button class="menububble-button h2"
                    :class="{ 'is-active': isActive.paragraph({ tag: 'h2' }) }"
                    @mousedown="{ cancelBlur(paraHeading, {isActive, commands, tag: 'h2'}); }"
                    >
                  </button>
                  <button class="menububble-button h3"
                    :class="{ 'is-active': isActive.paragraph({ tag: 'h3' }) }"
                    @mousedown="{ cancelBlur(paraHeading, {isActive, commands, tag: 'h3'}); }"
                    >
                  </button>
                  <button class="menububble-button b"
                    :class="{ 'is-active': isActive.bold() }"
                    @mousedown="{ cancelBlur(markStyle, {isActive, commands, param: 'bold'}); }">
                  </button>
                  <button class="menububble-button i"
                    :class="{ 'is-active': isActive.italic() }"
                    @mousedown="{ cancelBlur(markStyle, {isActive, commands, param: 'italic'}); }">
                  </button>
                  <button class="menububble-button strikethrough"
                    :class="{ 'is-active': isActive.strike() }"
                    @mousedown="{ cancelBlur(markStyle, {isActive, commands, param: 'strike'}); }">
                  </button>
                  <button class="menububble-button underline"
                    :class="{ 'is-active': isActive.underline() }"
                    @mousedown="{ cancelBlur(markStyle, {isActive, commands, param: 'underline'}); }">
                  </button>

                  <button slot="trigger"
                    ref="colorPickerBtn"
                    class="menububble-button swatches"
                    :class="{ 'is-active': isActive.span_element({ color: color }) }"
                    @mousemove="showColorPicker(1, null)"
                    @mouseout="showColorPicker(0, null)"
                    >
                  </button>
                  <div ref="colorPickerBdy" 
                    class="hidden" 
                    @mousemove="showColorPicker(1, null)"
                    @mouseout="showColorPicker(0, null)"
                    style="position:absolute;">
                    <div class="vue-swatches__container clear col-4" style="position:relative;top:45px">
                      <button 
                        @click="setColorFromPicker($event, c, commands, null)"
                        v-for="(c, inx) in swatches"
                        :key="inx"
                        :class="'hw-color-bg-' + inx + ' ' + (isSetColor(c) ? 'active' : '')">
                      </button>
                    </div>
                  </div>
                  <!--custom alignment -->
                  <button class="menububble-button left"
                    :class="{ 'is-active': isActive.paragraph({ textAlign: 'left' }) }"
                    @mousedown="{ cancelBlur(paraAlign, {isActive, commands, align: 'left'}); }"
                    >
                  </button>
                  <button class="menububble-button center"
                    :class="{ 'is-active': isActive.paragraph({ textAlign: 'center' }) }"
                    @mousedown="{ cancelBlur(paraAlign, {isActive, commands, align: 'center'}); }"
                    >
                  </button>
                  <button class="menububble-button right"
                    :class="{ 'is-active': isActive.paragraph({ textAlign: 'right' }) }"
                    @mousedown="{ cancelBlur(paraAlign, {isActive, commands, align: 'right'}); }"
                    >
                  </button>
                </div>
              </editor-menu-bubble>
              <!-- /[editor bubble bar 영역] -->
              <!-- [Tiptap Editor 영역] -->
              <div ref="editorWrapper"
                v-if="paperInfo.permission == 2"
                class="editor-wrapper"
                @input="editorKeyInput"
                @keyup="editorKeyUpHandle"
                @keydown="editorKeyDownHandle"
                @drop="editorDrop"
                @paste="pasted"
                @click="clickEditor(editor)"
                >
                <div ref="usageMsg"
                  class="board_txt message hidden" 
                  @click="editor.focus()"
                  v-if="(blockType() === BTPS().CONTENT || checkLockOwn() === OTPS().OWNER) && blockType() !== BTPS().TABLE && !editor.isActive.table()"
                  >
                  <template v-if="boardSection[0] !== 'SHAR'">
                    {{$i18nUtil.trans("message.ContentBlockTypeContent.002","'@이름'을 입력하여 멤버를 호출하고 내용을 입력한 후 할 일, 파일 등을 추가해보세요.")}}<br>
                  </template>
                  <template v-else>
                    {{$i18nUtil.trans("message.ContentBlockTypeContent.003","'@이름'을 입력하여 멤버를 호출하고 내용을 입력한 후 이미지, 파일 등을  추가해보세요.")}}
                  </template>
                </div>
                <editor-content 
                  ref="editor" :editor="editor" />
              </div>
              <div
                v-else-if="(paperInfo.permission == 1) 
                          && boardSection[0] == 'SHAR'
                          && paperInfo.categoryInfo.docGrade == 'NORMAL'
                          && paperInfo.docGrade == 'SECRET' "
                class="editor-wrapper"
                >
               <editor-content 
                   :editor="editor" ref="editor" />
              </div>
              <div v-else class="editor-wrapper"
                v-html="bdata.contentPath">
              </div>
              <!-- [/Tiptap Editor 영역] -->
            </template>
            <!-- /[에디터타입 블럭] -->
            <div v-else><em>Connecting to socket server …</em></div>
          </div>
          <!-- [의견 영역] -->
          <div
            ref="buttonComment"
            class="hover_comment"
            :class="
            (commentCount ? ' display-block' : '') +
            (blockInfo.commentSelectId === bdata.paperBlockId ? ' display-block active' : '')
            "
            >
            <button type="button" class="permit_everyone" @click="viewComment">
              {{ !commentCount ? "" : commentCount }}
            </button>
          </div>
          <!-- /[의견 영역] -->
        </div>
        <!-- /[rowbox] -->
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { Editor, EditorContent, EditorMenuBar, EditorMenuBubble } from "tiptap";
import { mapState, mapActions } from "vuex";
import {
  Heading,
  //OrderedList,
  BulletList,
  ListItem,
  Bold,
  //Italic,
  Link,
  //Strike,
  Underline,
  History,
  Focus,
  Table,
  TableHeader,
  TableCell,
  TableRow,
  Image
} from "tiptap-extensions";
import Datepicker from "vuejs-datepicker";
import Italic from "../extensions/Italic";
import Strike from "../extensions/Strike";
import OrderedList from "../extensions/OrderedList";
import Paragraph from "../extensions/Paragraph";
import WrapElement from "../extensions/WrapElement";
import SpanElement from "../extensions/SpanElement";
import TableBackgroundColor from "../extensions/TableBackgroundColor";
import lodash from "lodash";
import ContentBlockCreatorInfo from "./ContentBlockCreatorInfo";

export default {
  components: {
    Datepicker,
    EditorContent,
    EditorMenuBar,
    EditorMenuBubble,
    ContentBlockCreatorInfo,
    WrapElement,
    SpanElement,
    Paragraph,
    Italic,
    Strike,
    TableBackgroundColor
  },
  props: {
    paperInfo: Object,
    blockInfo: Object,
    boardMemberInfo: Object,
    boardSection: Array,
    bdata: Object,
    transmitter: Object,
    userInfo: Object,
    paperBlockIdList: Array,
    paperBlockMap: Object,
    boardUtil: Object,
    context: Object,
    memberSelector: Object,
    paperBlockId: String,
    focusedTableBlockId: String,
    tableCommands: Object,
    focusTableActive: Object,
    isRoute: Boolean
  },
  data() {
    return {
      pdata: this.bdata,
      editable: false,
      keepInBounds: true,
      loading: true,
      editor: null,
      messageList: [],
      files: [],
      color: this.boardUtil.colors[0],
      swatches: this.boardUtil.colors,
      state: {
        tenantId: localStorage.getItem("tenantId"),
        handleSubmit: null,
        twidths: [],
        rwidths: [],
        kbdIntrProcs: { },
        cs: [
          [-1, -1],
          [-1, -1],
          [-1, -1],
          [-1, -1]
        ],
        isIE: [false],
        splited:false,
        minPosition: false
      },
      userList: [],
      commentCount: this.blockInfo.commentCounts[this.bdata.paperBlockId],
      members: this.boardMemberInfo.userList,
      files: [],

      defaultLanguage : localStorage.getItem("defaultLanguage") || 'ko',

      blockModDate : '',
      blockRegDate: '',
      blockModUserName:'',
      blockRegUserName:'',
      emptyBlock:true,
      /* 전체멤버 호출 시, userId 값 */
      allMemberId: 'cowork.mention.allMember',
      
      tableBubbleMenu : 'TABLE', /* 테이블 버블 메뉴용 */
    };
  },
  created() {
    this.context.eventBusProc(this);
    this.context.initContentBlock(this);
    if (this.blockType() === this.BTPS().TABLE) {
      window.removeEventListener("resize", this.resizeContent);
      window.addEventListener("resize", this.resizeContent);
      // window.removeEventListener("resize", this.resizeTable);
      // window.addEventListener("resize", this.resizeTable);
    }
  },
  beforeUnmount(){
    // 브라우저가 새로고침 or 닫힐 경우 락 해제 이벤트 remove
   // window.removeEventListener('beforeunload',this.browserEvent);
  },
  mounted() {
    let self = this;
    self.transmitter.subscribers[self.bdata.paperBlockId] = {
      subscribe: function(command, data, error) {
        self.stompEditorSubscribe(command, data, error);
      }
    };
    self.onConnected();
    self.renderCompleted(() => {
      self.$emit("blockMatch");
      self.resizeContent();
      self.detectImages();
    });
    self.CHECK_IE({res: self.state.isIE});

    // 브라우저가 새로고침 or 닫힐 경우 락 해제 이벤트 add
    window.addEventListener('beforeunload',this.checkLockOwn() === this.OTPS().OWNER ? this.setDisableEditable():null);
  },
  updated() {
    let self = this;
    this.$nextTick(() => {
      this.onEditorContentRendered();
      let bdata = this.bdata;
      if (bdata.clickBtn) {
        let btn = self.$el.querySelector("." + bdata.clickBtn);
        btn.click();
        delete bdata.clickBtn;
      }
      // this.resizeTable(true);
    });
    let element = false;
    if ((element = this.$refs.menubar) && !element.$el.onmousemove) {
      let el = element.$el;
      el.onmousemove = function(e) {
        if (self.$refs.menububble) {
          self.$refs.menububble.$el.style.zIndex = 99;
          el.style.zIndex = 999;
          
        }
      };
    }
    if ((element = this.$refs.menububble) && !element.$el.onmousemove) {
      let el = element.$el;
      el.onmousemove = function(e) {
        if (self.$refs.menubar) {
          self.$refs.menubar.$el.style.zIndex = 99;
          el.style.zIndex = 999;
        }
      };
    }
  },
  beforeDestroy() {
    delete this.transmitter.subscribers[this.bdata.paperBlockId];
    window.removeEventListener('beforeunload',this.checkLockOwn() === this.OTPS().OWNER ? this.setDisableEditable():null);
      if(this.checkLockOwn() === this.OTPS().OWNER) {
        this.setDisableEditable();
      }
  },
  computed: {
    ...mapState("evdControl", ["KEYCODES", "EVENT_TYPES"]),
    ...mapState("noti", ["notiBoardBlockId"]),
  },
  watch: {
    editable() {
      this.tracelog("EDITABLE:", this.editable);
    //   this.editor.setOptions({
    //     editable: this.editable
    //   });
    },
    isRoute() { // 뒤로가기 할 경우 본인 락 해제
      if(this.checkLockOwn() === this.OTPS().OWNER) {
        this.setDisableEditable();
      }
    },
    "pdata.blockLockYn"() { },
    "pdata.contentPath"() { },
    "pdata.sortNo"() { },

    /** 테이블: 셀 색상 외 이벤트 전달 **/
    "focusTableActive.click"() {
      if (this.editor.isActive.table() && this.focusedTableBlockId === this.paperBlockId) {
        let fnc = this.focusTableActive;
        let commands = fnc.function;
        if(fnc.param === 'tableCellColor') {
          this.cancelBlur();
        }
        if (fnc.function === null && fnc.param === null) {
          this.cancelBlur();
        } 
        else if (fnc.function !== null && fnc.param === null) {
          this.cancelBlur(fnc.function);
        }
        else if (fnc.function !== null && fnc.param !== null) {
          if (fnc.param !== 'deleteBlock') {
            let isActive = this.editor.isActive;
            let param = fnc.param;
            this.cancelBlur(this.markStyle({isActive, commands, param: param}));
          }else {
            // 표 삭제
            this.cancelBlurBranch(commands.deleteTable, this.deleteBlock);
            this.$emit("focusTable", false, null, null); // 표 버블 메뉴 숨김
          }
        }
      }
    }
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    ...mapActions("coworkUtils", ["HW_KEYGEN", "CHECK_IE", "IMG_TO_BLOB", "COPY_ELEMENT", "CHECK_AND_LAUNCH", "B642BLOB", "HW_LOAD_IMAGE"]),
    ...mapActions("evdControl", ["CREATE_EVENT", "TRIGGER_EVENT", "CANCEL_EVENT"]),
    browserEvent: function(event){
      if(this.checkLockOwn() === this.OTPS().OWNER) {
        this.setDisableEditable();
      }
 // 브라우저가 새로고침 or 닫힐 경우 락 해제 이벤트 remove
    //  window.removeEventListener('unload',this.browserEvent);
      
    },

    contentBlockAPI(sendId, param) {
      let res = [];

      if (sendId == "updateBlock") {
        if (!this.prevHtml || this.prevHtml != this.html) {
          /* 마지막 업데이트이후 변경사항이 존재하는지 */
          // console.log("MODIFIED!");
          this.pinBlockCheck();
          this.prevHtml = this.html;
        }
        else {
          // console.log("NOT MODIFIED!");
          return;
        }
        /* BASE64 바이너리가 전송되는 현상 막음 */
        if (/[<]img src=\"data:[a-zA-Z0-9\/]+;base64,/g.exec(this.html)) {
          console.log("BASE64 BINARY FOUND!. NO-UPDATE!", this.bdata.paperBlockId);
          return;
        }
      }
      this.HW_KEYGEN({head: "UPDT", res});
      let updateToken = res[0];
      this.boardUtil.addUpdateToken(updateToken);
      let params = {
        setEnableEditable: {
          uri: "/block/blockLockYn",
          param: {
            paperId: String(this.paperInfo.paperId),
            paperBlockId: String(this.bdata.paperBlockId),
            blockLockYn: "1",
            userName: this.userInfo.userName,
            updateToken: updateToken
          }
        },
        setDisableEditable: {
          uri: "/block/blockLockYn",
          param: {
            paperId: String(this.paperInfo.paperId),
            paperBlockId: String(this.bdata.paperBlockId),
            blockLockYn: "0",
            updateToken: updateToken
          }
        },
        updateBlock: {
          uri: "/block/updateBlock",
          param: {
            paperId: String(this.paperInfo.paperId),
            paperBlockId: String(this.bdata.paperBlockId),
            blockType: this.bdata.blockType,
            sortNo: String(this.bdata.sortNo),
            blockLockYn: String(this.bdata.blockLockYn),
            userName: String(this.bdata.blockLockName),
            content: this.html ? this.html.replace(/[ \0]/g, " ") : "",
            updateToken: updateToken
          }
        },
        deleteBlock: {
          uri: "/block/deleteBlock",
          param: {
            paperId: String(this.paperInfo.paperId),
            groupId: String(this.paperInfo.groupId),
            paperBlockId: String(this.bdata.paperBlockId),
            fileId: this.bdata.fileId ? String(this.bdata.fileId) : null,
            sortNo: String(this.bdata.sortNo),
            blockMoveTo: param && param.blockMoveTo ? param.blockMoveTo : null,
            updateToken: updateToken
          }
        }
      };
      this.boardUtil.apiCall(params[sendId]);
    },
    /* 에디터 수정하도록 설정 */
    setEnableEditable() {
      let self = this;
      self.tracelog("ENABLE-EDIT");
      self.state.prevKeycode = null;
      self.state.keyCode = null;
      if (self.checkLockOwn() != self.OTPS().OWNER) {
        if (self.checkLockOwn() === self.OTPS().ANOTHER) {
          self.editable = false;
          console.log("수정중 ID : " + self.bdata.blockLockName + "\n접근중 ID : " + self.userInfo.userName);
          return;
        }

        // 2021.12.01 IE 블럭을 점유하지 못하는 현상 발생 > 버블 메뉴 뜨지 않아 주석처리
        // if (self.editable === true) {
        //   return;
        // }

        /* 내가 가지고 있는 블럭이 있다면 먼저 꺼준다. */
        self.paperBlockIdList.forEach(blockId => {
          let element = self.paperBlockMap[blockId].element;
          if (element && element.checkLockOwn() === self.OTPS().OWNER) {
            element.bdata.blockLockYn = 0;
            element.bdata.blockLockId = "";
            element.bdata.blockLockName = "";
            element.bdata.blockLockNameEn = "";
          }
        });

        /* 편집자는 먼저 처리해 주도록  */
        self.bdata.blockLockYn = 1;
        self.bdata.blockLockId = self.userInfo.userId;
        self.bdata.blockLockName = self.userInfo.userName;
        self.bdata.blockLockNameEn = self.userInfo.userNameEn;
        self.editable = true;
        self.contentBlockAPI("setEnableEditable");
      }
    },
    /* 에디터 수정 불가하도록 설정 */
    setDisableEditable() {
      this.tracelog("DISABLE-EDIT");
      this.editable = false;
      if (this.checkLockOwn() === this.OTPS().OWNER) {
        this.$emit("focusTable", false, null, null); // 표 버블 메뉴 숨김
        this.contentBlockAPI("setDisableEditable");
        let bdata = this.bdata;
        bdata.blockLockYn = 0;
        bdata.blockLockId = "";
        bdata.blockLockName = "";
        bdata.blockLockNameEn = "";
      }
    },
    /* 블럭 추가 */
    updateBlock() {
      this.tracelog("UPDATE-BLOCK");
      if (this.checkLockOwn() === this.OTPS().ANOTHER) {
        console.log("다른 사용자가 작성중입니다. / (" + this.bdata.blockLockName + ")");
        return;
      }
      this.contentBlockAPI("updateBlock");
    },
    /* 블럭 삭제 */
    deleteBlock(param) {
      this.tracelog("DELETE-BLOCK");
      let blockIndex = this.bdata.index;
      let blockId = this.bdata.paperBlockId;
      if (
        this.blockType() === this.BTPS().CONTENT &&
        this.checkLockOwn() === this.OTPS().ANOTHER
      ) {
        console.log("다른 사용자가 작성중입니다.");
        return;
      }
      this.boardUtil.removeBlockData(blockId);
      this.blockInfo.deletedBlocks.push(blockId);
      this.contentBlockAPI("deleteBlock", param);
    },
    initEditor({ doc, version }) {
      this.tracelog("INIT-EDITOR");
      let self = this;
      let util = self.boardUtil;
      self.loading = false;
      if (self.editor) {
        self.editor.destroy();
      }
      if (self.paperInfo.permission > 1) {
        if (!self.editable) {
          self.editable = false;
        }
      }
      let editorParam = {
        editable: true,
        parseOptions: {
          preserveWhitespace: true
        },
        onInit: ({ state, view }) => { },
        onTransaction: ({ state }) => {
          self.tracelog("EDITOR-TRANS");
          {
            /* 키 이벤트 처리 : input 이벤트 처리가 호환되지 않기때문에 편법을 이용한다  */
            let ms = self.memberSelector;
            let input = self.$el.querySelector("div[contenteditable]");
            if (ms && ms.state && ms.state.target && ms.state.target === input) {
              let res = [0];
              self.CREATE_EVENT({type: this.EVENT_TYPES.KEYDOWN, attr: { keyCode: self.KEYCODES.SHIFT }, res});
              let evt = res[0];
              ms.editorKeyInput(evt);
            }
          }
          if (self.$refs.menubar &&
            self.$refs.menubar.$el.classList.contains("mock_table_bubble_menubar")) {
          /* if (self.$refs.menubar &&
            self.$refs.menubar.$el.querySelectorAll("span.table_menus button").length > 0) { */
            
            /* TODO:테이블의 경우 락이 걸려 있어도 칼럼사이즈 변경이 가능하므로 이럴 처리해야 함. */
            /* 테이블메뉴와 버블메뉴 충돌감지 */

            if (self.$refs.menubar && self.$refs.menububble) {
              let mnuTbl = self.$refs.menubar.$el;
              let mnuBbl = self.$refs.menububble.$el;

              setTimeout(() => {
                let scells = self.$el.querySelector("div[contenteditable] tr>.selectedCell");
                let cancelhandle = setTimeout(() => {
                  mnuTbl.style.zIndex = 999;
                  mnuBbl.style.zIndex = 99;
                  mnuTbl.classList.remove("hidden");
                  mnuBbl.classList.remove("hidden");
                }, 100);

                if (mnuTbl && mnuBbl) {
                  if (!scells && mnuBbl.classList.contains("is-active")) {
                    if (cancelhandle) { clearTimeout(cancelhandle); }
                    mnuTbl.style.zIndex = 99;
                    mnuBbl.style.zIndex = 999;
                    mnuTbl.classList.add("hidden");
                    mnuBbl.classList.remove("hidden");
                  }
                  else if (scells) {
                    if (cancelhandle) { clearTimeout(cancelhandle); }
                    mnuTbl.style.zIndex = 999;
                    mnuBbl.style.zIndex = 99;
                    mnuTbl.classList.remove("hidden");
                    mnuBbl.classList.add("hidden");
                  }
                }
              }, 100)
            }
          }
          if (self.innerText(1).length > 0) {
            delete self.bdata.isTemp;
            if (self.$refs.buttonComment) {
              self.$refs.buttonComment.firstChild.classList.remove("hidden");
            }
            self.toggleUsageMsg(true);
          }
        },
        onBlur: ({ event, state, view }) => {
          self.tracelog("EITOR-BLUR");
          // {
          //   /**
          //    * TIPTAP 에디터는 BLUR 시 편집중이던 선택영역을 저장하므로
          //    * 이를 초기화 해주도록 한다.
          //    **/
          //   let selec = document.getSelection();
          //   let range = selec ? selec.getRangeAt(0) : false;
          //   let acon = range ? range.commonAncestorContainer : false;
          //   let scon = range ? range.startContainer : false;
          //   let econ = range ? range.endContainer : false;
          //   console.log("BLUR:", range, acon, scon, econ);
          //   selec.collapse(econ, range.endOffset);
          //   setTimeout(() => { this.editor.blur(); }, 1);
          // }

          let element = self.$el.querySelector("div[contenteditable]");
          self.memberSelector.cancelMemberSelect(element);
          let text = self.innerText(1);

          self.toggleUsageMsg(false);

          if (!text && self.bdata.isTemp) {
            self.state.handleSubmit = setTimeout(() => {
              console.log("DELETE EMPTY BLOCK!", self.bdata.paperBlockId);
              self.deleteBlock();
              delete self.bdata.isTemp;
            }, 500);
          }

          /**
           * 테이블의 경우 모든 칼럼의 크기를 알아야 재생시 상대폭으로 재계산이 가능하므로
           * 모든 비어있는 칼럼크기를 다시 채워주도록 한다. (Tiptap 에디터 제약사항)
           */
          if(self.checkLockOwn() === self.OTPS().OWNER) {
            /* 클릭이벤트를 먼저 받고 온 경우 */
            if (self.state.handleSubmit === -1) {
              self.state.handleSubmit = null;
            }
            else {
              self.state.caretPos = state.selection.$anchor.pos;
              /* 마우스 커서가 벗어날 시 동작 */
              self.updateBlock();
              self.state.handleSubmit = setTimeout(() => {
                self.setDisableEditable();
              }, 500);
            }
          }
        },
        onUpdate: ({ node, state, transaction }) => {
          self.tracelog("EDITOR-UPDATE");
          lodash.debounce(()=> {
            /* 테이블일경우 불필요한 Wrapper 태그를 벗긴다 */
            self.html = self.innerHTML(1);
          }, 100)();
        },
        onFocus: ({ event, state, view }) => {
          self.tracelog("EDITOR-FOCUS");
          if (!self.focusable()) {
            self.editor.blur();
          }
          else {
            self.toggleUsageMsg(true);
            self.setEnableEditable();
          }
        },
        content: "",
        extensions: [
          new BulletList(),
          new Heading({ levels: [1, 2, 3] }),
          new ListItem(),
          new OrderedList(this.tenantId),
          new Link(),
          new Bold(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          new Focus({ className: "has-focus", nested: true }),
          new Table({ resizable: true }),
          new TableHeader(),
          new TableCell(),
          new TableRow(),
          new Image(),
          new Paragraph(),
          new WrapElement(),
          new SpanElement(),
          new TableBackgroundColor(),
        ]
      };
      self.editor = new Editor(editorParam);
      self.html = self.bdata.contentPath;
      self.prevHtml = self.html;

      if(self.paperInfo.permission == 1){
        if (!self.editable) {
          if(self.boardSection[0] == 'SHAR'
             && self.paperInfo.categoryInfo.docGrade == "NORMAL"
             && self.paperInfo.docGrade == "SECRET"){
            self.editor.setOptions({
              editable: false
            });
          }
        }
      }
    },
    onConnected() {
      this.tracelog("CONNECTED");
      if (this.checkLockOwn() === this.OTPS().OWNER) {
        this.editable = true;
      }
      else {
        this.editable = false;
      }
      let elem = document.createElement("div");
      // 이벤트 제거
      let temp = $(this.bdata.contentPath).removeAttr("onerror onload onLoadstart onResize onStart onBegin");
      let tempHtml = "";
      if (temp.length > 0) {
        temp.each((index, el) => {
          tempHtml += el.outerHTML;
        })
      } else {
        temp = this.bdata.contentPath;
      }
      elem.innerHTML = tempHtml;
      let images = elem.querySelectorAll("span[data-from-block]>img[src]");
      for (let image of images) { image.src = "//:0"; }
      this.initEditor(this.messageList);
      this.setContent(elem.innerHTML);
    },
    setContent(content) {
      this.tracelog("SET-CONTENT");
      this.editor.setContent(content);
      self.emptyBlock = true;
      this.checkEmptyBlock();
    },
    stompEditorSubscribe(command, bdata, error) {
      let self = this;
      let updateToken = null;
      let editingMap = self.blockInfo.editingMap;
      if (command === "content") {
        if (bdata.paperId === self.paperInfo.paperId &&
          bdata.paperBlockId === self.bdata.paperBlockId) {
          updateToken = bdata.updateToken;

          if(bdata.modDate != null){
            self.blockModDate = bdata.modDate;
            self.blockModUserName = this.$i18nUtil.getLanguage() === 'en' && bdata.blockLockNameEn !== null ? bdata.blockLockNameEn : bdata.blockLockName;
          }
          if(bdata.regDate != null){
            self.blockRegDate = bdata.regDate;
            self.blockRegUserName = this.$i18nUtil.getLanguage() === 'en' && bdata.regUserNameEn !== null ? bdata.regUserNameEn : bdata.regUserName;
          }

          if (updateToken && self.boardUtil.findUpdateToken(updateToken) != -1) {
            /* 전파자가 보낸신호는 되받지 않음 */
            self.bdata.contentPath = bdata.content;
            this.checkEmptyBlock();
            self.boardUtil.removeUpdateToken(updateToken);
            return true;
          }
          self.bdata.contentPath = bdata.content;
          self.setContent(bdata.content);
          if (bdata.blockLockYn && bdata.blockLockId) {
            let pblock = editingMap[bdata.blockLockId];
            if (pblock && pblock.bdata) {
              pblock.bdata.blockLockYn = 0;
              pblock.bdata.blockLockId = null;
              pblock.bdata.blockLockName = null;
              pblock.bdata.blockLockNameEn = null;
            }
            self.bdata.blockLockYn = Number(bdata.blockLockYn);
            self.bdata.blockLockId = bdata.blockLockId;
            self.bdata.blockLockName = bdata.blockLockName;
            self.bdata.blockLockNameEn = bdata.blockLockNameEn;
            self.bdata.modDate = bdata.modDate;
          }
          else {
            self.bdata.blockLockYn = 0;
            self.bdata.blockLockId = null;
            self.bdata.blockLockName = null;
            self.bdata.blockLockNameEn = null;
          }
          self.editable = false;
          self.html = bdata.content;
          /* 이미지가 업로드 중일수 있기 때문에 막바로 찾지는 않는다 */
          setTimeout(() => {
            let div = document.createElement("div");
            div.innerHTML = bdata.content;
            let list = div.querySelectorAll("span[data-from-block]>img");
            for (let img of list) {
              let blockId = img.parentNode.getAttribute("data-from-block");
              // console.log("LINK-IMG:", img, blockId);
              self.registerBlockTrigger(blockId, self.detectImages);
            }
          }, 1);
          self.detectImages(false);
          return true;
        }
      }
      else if (command === "paperBlockLock") {
        /* 블록 LOCK 설정 */
        if (bdata.paperId === self.paperInfo.paperId &&
          bdata.paperBlockId === self.bdata.paperBlockId) {
          updateToken = bdata.updateToken;
          if (updateToken && self.boardUtil.findUpdateToken(updateToken) != -1) {
            /* 전파자가 보낸신호는 되받지 않음 */
            self.boardUtil.removeUpdateToken(updateToken);
            return true;
          }
          if (bdata.blockLockYn === 0) {
            self.editable = false;
            self.bdata.blockLockYn = 0;
            self.bdata.blockLockId = null;
            self.bdata.blockLockName = null;
            self.bdata.blockLockNameEn = null;
          }
          else {
            /* !COLLISION! 동시에 같은 블럭에 락을 시도한 경우 */
            if (self.checkLockOwn() === self.OTPS().OWNER && bdata.blockLockName &&
              self.bdata.blockName != bdata.blockLockName) {
              console.log("Block Lock Collision! : " + self.bdata.blockLockName + " / " + bdata.blockLockName);
              self.bdata.blockLockYn = 0;
              self.bdata.blockLockId = null;
              self.bdata.blockLockName = null;
              self.bdata.blockLockNameEn = null;
              self.editable = false;
              // self.editor.setOptions({ editable: false });
              /* 동시에 같은 블럭을 건드렸으므로 소유자 체크를 하지 않고 즉시 해지한다 */
              self.contentBlockAPI("setDisableEditable");
            }
            else {
              if (editingMap[bdata.blockLockId]) {
                let prevId = editingMap[bdata.blockLockId];
                let pblock = self.paperBlockMap[prevId];
                if (prevId != bdata.paperBlockId && pblock && pblock.bdata) {
                  // console.log("FREE PREV BLOCK:", prevId, pblock.blockLockId,
                  //   bdata.paperBlockId, bdata.blockLockId);
                  pblock.bdata.blockLockYn = 0;
                  pblock.bdata.blockLockId = null;
                  pblock.bdata.blockLockName = null;
                  pblock.bdata.blockLockNameEn = null;
                }
              }
              self.editable = false;
              self.bdata.blockLockYn = Number(bdata.blockLockYn);
              self.bdata.blockLockId = bdata.blockLockId;
              self.bdata.blockLockName = bdata.blockLockName;
              self.bdata.blockLockNameEn = bdata.blockLockNameEn;
              editingMap[bdata.blockLockId] = bdata.paperBlockId;
            }
          }
          return true;
        }
      }
      return false;
    },
    toggleUsageMsg(focused) {
      if (this.$refs.usageMsg) {
        if (focused && this.innerText(true).length == 0) {
          this.$refs.usageMsg.classList.remove("hidden");
        }
        else {
          this.$refs.usageMsg.classList.add("hidden");
        }
      }
    },
    editorKeyInput(e) {
      if (e.keyCode === undefined) { this.CANCEL_EVENT({event: e}); return; }
      if (!this.memberSelector.editorKeyInput(e)) { return; }
    },
    editorKeyUpHandle(e) {
      /** 엔터키가 두번이상 연속으로 들어오는 경우 보정 로직. 
       * editorKeyUpHandlePrevKeyInit로 prevKeyCode가 null이
       * 되기전에 다시 엔터가 쳐지는 경우 오동작.
       * processKeyDown()에서 블록을 나눈후 prevKeyCode값을 null처리해도
       * 세번째 엔터가 들어오면서 다시 세팅하기 때문에 여기서 후처리해줌.
       * skyoon 211022 */
      
      if(!this.state.splited){
        this.state.prevKeycode = this.state.keyCode;
      }
      this.state.splited = false;
      this.boardUtil.copyKbdAttr(e, this.state);
      if (!this.memberSelector.keyboardInterrupt(e)) {
        return;
      }
      else {
        this.editorKeyUpHandleWrapper(e);
        this.editorKeyUpHandlePrevKeyInit(e);
      }
    },
    editorKeyUpHandleWrapper: lodash.debounce(function(e) {
      if (e) {
        this.contentBlockAPI("updateBlock");
        //this.state.prevKeycode = null;
      }
    }, 400),
    //엔터 두번 입력할때 이전 입력 키 초기화 분리 skyoon 211022
    editorKeyUpHandlePrevKeyInit: lodash.debounce(function(e) {
      if (e) {
        this.state.prevKeycode = null;
      }
    }, 200),
    editorKeyDownHandle(e) {
      let self = this;
      self.boardUtil.copyKbdAttr(e, self.state);
      if (e.keyCode == self.KEYCODES.TAB) {
        /* 키 가로채기 */
        self.CANCEL_EVENT({event: e});
      }
      self.processKeyDown(e);
    },
    memberSelectorPosition(pos, caret) {
      let wscrollTop = window.scrollY || window.pageYOffset;
      pos.top = this.$el.offsetTop;
      pos.left = this.$el.offsetLeft;
      if (pos.top - wscrollTop < 400) {
        pos.reverse = true;
      }
    },
    memberSelectorCallback(isCancel, item, caretElement) {
      let self = this;
      let editor = self.editor;
      let $anchor = editor.state.selection.$anchor;
      // console.log($anchor);
      let pos1 = $anchor.pos;
      let pos2 = pos1;
      /* IE에서는 커서위치가 다름 */
      if (!isCancel && self.state.isIE[0]) {
        pos1 = pos1 + 1;
        pos2 = pos2 - 1;
      }
      else if (isCancel && self.state.isIE[0]) {
        pos1 = pos1 + 1;
        if (caretElement && caretElement.tag) {
          pos2 = pos2 - caretElement.tag.innerText.length - 1;
        }
      }
      else if (!isCancel && !self.state.isIE[0]) {
        pos1 = pos1 + 1;
        pos2 = pos2 - 1;
      }
      else if (isCancel && !self.state.isIE[0]) {
        pos1 = pos1 + 1;
        if (caretElement && caretElement.tag) {
          pos2 = pos2 - caretElement.tag.innerText.length;
        }
      }
      self.caretPosition(pos1);
      setTimeout(() => {
        let marks = self.editor.state.storedMarks;
        if (marks && marks.length > 0) {
          marks.splice(0, marks.length);
          self.caretPosition(pos2);
        }
      }, 10);
      // console.log("MEMBER SELECTED:", isCancel, caretElement);
      /**
       * 멤버 호출시 chinesewall 에 대한 방안
       * 1. 최초 보드(혹은 과제) 멤버 목록 적재시 차단여부 불러옴
       * 2. 호출 프로세스를 람다콜백으로 선언
       * 3. 멤버에 있고, 차단대상이 아니면 바로 프로세스 실행
       * 4. 멤버에 없다면 람다콜백을 state 에 등록
       * 5. 초대 프로세스 실행하여 성공하면 state 에 등록된 람다콜백 실행
       */
      if (!isCancel && item) {
        let userId = item.getAttribute("data-user-id");
        let userName = item.getAttribute("data-user-name");
        let companyId = item.getAttribute("data-company-id");
        let callFindKey = item.getAttribute("data-callEx-id");

        if (userId && userName) {
          /* 호출태그 삭제. 100ms 정도 간격을 두고 실행한다. */
          let tagElement = caretElement.element;
          let parentElement = tagElement.parentNode;
          let squery = "span.mention[data-user-id='" + userId + "']";
          let tagElements = parentElement.querySelectorAll(squery);
          let tagIndex = 0;
          for (let tinx of Object.keys(tagElements)) {
            if (tagElement == tagElements[tinx]) {
              tagIndex = tinx;
              break;
            }
          }
          let removeTag = () => {
            if (!parentElement.contains(tagElement)) {
              tagElement = parentElement.querySelectorAll(squery)[tagIndex];
            }
            console.log("REMOVE-TAG", tagElement, parentElement);
            let element = tagElement;
            let parent = parentElement;
            parent.removeChild(element);
            setTimeout(() => {
              self.contentBlockAPI("updateBlock");
              let marks = self.editor.state.storedMarks;
              if (marks && marks.length > 0) {
                marks.splice(0, marks.length);
              }
            }, 10);
            self.toast(self.$i18nUtil.trans("message.ProjectComment.001","사용자를 초대할수 없습니다."));
          };
          self.state.callMemberProcess = (success) => {
            console.log("CALL-USER:", userName, success);
            if (success) {
              let action = "/api/copaper/paper/paperBlockCallUser";
              let param = {
                paperBlockId: self.bdata.paperBlockId,
                mentionId: userId,
                mentionName: userName,
                companyId: companyId,
                allMember: userId === self.allMemberId ? true : false,
                callFindKey: callFindKey
              };
              self.COWORK_REST_ACTION({
                url: action,
                method: "post",
                req: param
              })
                .then(res => { })
                .catch(function(err) { console.log(err); });
            }
            else {
              setTimeout(removeTag, 100);
            }
          };
          /**
           * 여기서 호출되지 않으면 초대후 호출된다.
           * 2022-07-08 : 조성기
           *  정보고유 보드이고 전체공개 보드일경우 
           *  해당사용자가 멤버가 아니여도 호출 발송 
           */
          if(self.paperInfo.categoryInfo.section == "SHAR" && self.paperInfo.docGrade == "SECRET"){
            self.state.callMemberProcess(true);
            delete self.state.callMemberProcess;
          }else{
            for (let member of self.members) {
              if (member.userId == userId || userId === self.allMemberId) {
                self.state.callMemberProcess(true);
                delete self.state.callMemberProcess;
                break;
              }
            }
          }
        }
        else {
          /* TODO: 호출에 실패한경우 태그 삭제 처리여부 */
          console.log("Invalid user :", userId, userName);
        }
      }
    },
    processKeyDown(e) {
      let self = this;
      let util = self.boardUtil;
      let bdata = self.bdata;
      let blockIndex = bdata.index;
      let blockId = bdata.paperBlockId;
      let anchor = () => { return self.editor.state.selection.$anchor };
      let range = document.getSelection().getRangeAt(0);
      let prevKeycode = self.state.prevKeycode;
      let keyCode = self.state.keyCode;
      /* cs 자료구조는 BoardUtil.getCursorState 주석 참고 */
      /* pcs = previous cursor state */
      let pcs = self.state.cs;
      /* ccs = current cursor state */
      let ccs = util.getCursorState(self, anchor(), 0);
      /* ncs = next cursor state */
      let ncs = [[]];
      let KEYCODES = self.KEYCODES;
      let EVENT_TYPES = self.EVENT_TYPES;
      self.state.cs = ccs;
      if (!self.memberSelector.editorKeyDown(e, {
          positionAdjust: self.memberSelectorPosition,
          closeCallback: self.memberSelectorCallback,
          inviteCallback(success, userId, companyId, memberList, blockedList) {
            if (self.state.callMemberProcess) {
              if (blockedList != null && blockedList.length > 0) {
                success = false;
                console.log("BLOCKED:", blockedList);
              }
              self.state.callMemberProcess(success);
              delete self.state.callMemberProcess;
            }
            self.$emit("refreshBoardMemberInfo");
          },
          contentEditable: true,
          autoInvite: 1,
        })) {
        return false;
      }

      setTimeout(() => { self.toggleUsageMsg(true); }, 10)

      /* 2021.12.17. minPosition 초기화 */
      if (keyCode !== KEYCODES.ENTER || prevKeycode !== KEYCODES.ENTER || bdata.blockType !== self.BTPS().CONTENT) {
        self.state.minPosition = false; 
      }
      
      /* 2021.12.17. minPosition 설정 */
      if (keyCode === KEYCODES.ENTER && prevKeycode !== KEYCODES.ENTER && bdata.blockType === self.BTPS().CONTENT
          && (ccs[0][0] == 1 || ccs[0][0] == 3) && ccs[0][1] == 1) {
        /* 블럭 split: 블럭 처음에서 첫 번째 엔터가 시작되었는지 체크 */
        self.state.minPosition = true;
      }

      let current = range.startContainer;
      let tmpNode1 = current.parentNode;
      let tmpNode2 = current.nextSibling;
      let tmpNode3 = current.previousSibling;
      // console.log("OFFSET:" + keyCode + " / " + range.startOffset + " / " + current.length + " / " + 
      // current + " / " +
      // (tmpNode1 ? tmpNode1.nodeName : "#") + " / " + 
      // (tmpNode2 ? tmpNode2.nodeName : "#") + " / " + 
      // (tmpNode3 ? tmpNode3.nodeName : "#"));
      /* 멤버 호출 태그는 편집할수 없도록 */
      if (tmpNode3 && tmpNode3.nodeName == "SPAN" && tmpNode3.classList.contains("mention") &&
        tmpNode3.getAttribute("data-user-id") && 
        (range.startOffset === 0 || current.length == undefined)) {
        // console.log("EX-CASE1");
        if (keyCode == KEYCODES.BS) {
          tmpNode3.parentNode.removeChild(tmpNode3);
          self.CANCEL_EVENT({event: e});
          return false;
        }
      }
      else if (current && current.nodeName == "SPAN" && current.classList.contains("mention") &&
        current.getAttribute("data-user-id") && current.length == undefined) {
        // console.log("EX-CASE2");

        if (range.startOffset == 1 && keyCode == KEYCODES.BS) {
          let prevNode = current.previousSibling;
          if (!prevNode) {
            prevNode = document.createTextNode(" ");
            current.parentNode.insertBefore(prevNode, current);
          }
          current.parentNode.removeChild(current);
          document.getSelection().collapse(prevNode, prevNode.length - 1);
          self.CANCEL_EVENT({event: e});
          return false;
        }
        if (range.startOffset == 0 && keyCode == KEYCODES.DEL) {
          let nextNode = current.nextSibling;
          if (!nextNode) {
            nextNode = document.createTextNode(" ");
            current.parentNode.appendChild(nextNode);
          }
          current.parentNode.removeChild(current);
          document.getSelection().collapse(nextNode, 0);
          self.CANCEL_EVENT({event: e});
          return false;
        }
        if (range.startOffset == 0 && keyCode == KEYCODES.RIGHT) {
          if (tmpNode2) {
            document.getSelection().collapse(tmpNode2, 0);
          }
        }
        if (range.startOffset == 1 && keyCode == KEYCODES.LEFT) {
          if (tmpNode3) {
            document.getSelection().collapse(tmpNode3, tmpNode3.length);
          }
        }
        else if (range.startOffset == 1) {
          current.innerHTML = "@" + current.getAttribute("data-user-name");
          if (tmpNode2) {
            document.getSelection().collapse(tmpNode2, 0);
          }
        }
      }
      else if (tmpNode1 && tmpNode1.nodeName == "SPAN" && tmpNode1.classList.contains("mention") &&
        tmpNode1.getAttribute("data-user-id")) {
        // console.log("EX-CASE3");
        if (keyCode == KEYCODES.BS) {
          let prevNode = tmpNode1.previousSibling;
          if (!prevNode) {
            prevNode = document.createTextNode(" ");
            tmpNode1.parentNode.insertBefore(prevNode, tmpNode1);
          }
          tmpNode1.parentNode.removeChild(tmpNode1);
          document.getSelection().collapse(prevNode, prevNode.length);
          setTimeout(() => {
            let marks = self.editor.state.storedMarks;
            if (marks && marks.length > 0) {
              marks.splice(0, marks.length);
              range = document.getSelection().getRangeAt(0);
              prevNode = range.startContainer;
              document.getSelection().collapse(prevNode, range.startOffset);
            }
          }, 10);
          self.CANCEL_EVENT({event: e});
          return false;
        }
        else if (keyCode == KEYCODES.DEL) {
          let nextNode = tmpNode1.nextSibling;
          if (!nextNode) {
            nextNode = document.createTextNode(" ");
            tmpNode1.parentNode.appendChild(nextNode);
          }
          tmpNode1.parentNode.removeChild(tmpNode1);
          document.getSelection().collapse(nextNode, 0);
          setTimeout(() => {
            let marks = self.editor.state.storedMarks;
            if (marks && marks.length > 0) {
              marks.splice(0, marks.length);
              range = document.getSelection().getRangeAt(0);
              nextNode = range.startContainer;
              document.getSelection().collapse(nextNode, range.startOffset);
            }
          }, 10);
        }
        else if (keyCode == KEYCODES.LEFT) {
          document.getSelection().collapse(tmpNode1, 0);
        }
        else {
          if(tmpNode1.nextSibling == null){
            let nextNode = document.createTextNode(" ");
            tmpNode1.parentNode.appendChild(nextNode);
            document.getSelection().collapse(tmpNode1.nextSibling, 1);
          }else{
            document.getSelection().collapse(tmpNode1.nextSibling, 1);
          }
        }
        self.CANCEL_EVENT({event: e});
        return false;
      }
      else if (tmpNode2 && tmpNode2.nodeName == "SPAN" && tmpNode2.classList.contains("mention") &&
        tmpNode2.getAttribute("data-user-id") && range.endOffset >= range.endContainer.length) {
        // console.log("EX-CASE4");
        if (keyCode == KEYCODES.DEL) {
          let nextNode = tmpNode2.nextSibling;
          if (!nextNode) {
            nextNode = document.createTextNode(" ");
            tmpNode2.parentNode.appendChild(nextNode);
          }
          tmpNode2.parentNode.removeChild(tmpNode2);
          document.getSelection().collapse(nextNode, 0);
          setTimeout(() => {
            let marks = self.editor.state.storedMarks;
            if (marks && marks.length > 0) {
              marks.splice(0, marks.length);
              range = document.getSelection().getRangeAt(0);
              nextNode = range.startContainer;
              document.getSelection().collapse(nextNode, range.startOffset);
            }
          }, 10);
          self.CANCEL_EVENT({event: e});
          return false;
        }
        else if (keyCode == KEYCODES.RIGHT) {
          document.getSelection().collapse(tmpNode2, 1);
          self.CANCEL_EVENT({event: e});
          return false;
        }
      }
      else if (tmpNode2 && tmpNode2.nodeName == "P" && !tmpNode3 &&
        current.nodeName == "P" && current.length == undefined) {
        // console.log("EX-CASE5");
        let children = current.childNodes;
        if (children && children.length > range.startOffset && keyCode == KEYCODES.BS) {
          let tmpNode1 = children[range.startOffset - 1];
          
          if (tmpNode1 == undefined && ccs[0][0] <= ccs[0][1]) {
            /* 2021.10.08
             * 두번째 줄부터 텍스트가 쓰여있는 블럭의, 첫째 줄에서 Backspace 시 미동작
             * if (!tmpNode1) return false; 조건에 걸려 하위 코드 진행하지 않는 현상 발생하여 해당 if문 추가
             */
            setTimeout(() => {
              ncs = util.getCursorState(self, anchor(), 0);
              if (ccs[0][0] <= ccs[0][1] && ncs[0][0] <= ncs[0][1]) {
                // console.log ("MERGE PREV");
                util.mergeEditorBlock(blockId, 0);
              } }, 1);
            self.state.target = null;
            return false;
          } 

          if (!tmpNode1) {
            return false;
          }
          let prevNode = tmpNode1.previousSibling;
          if (!prevNode) {
            prevNode = document.createTextNode(" ");
            current.insertBefore(prevNode, tmpNode1);
          }
          current.removeChild(tmpNode1);
          document.getSelection().collapse(prevNode, prevNode.length);
          setTimeout(() => {
            let marks = self.editor.state.storedMarks;
            if (marks && marks.length > 0) {
              marks.splice(0, marks.length);
              range = document.getSelection().getRangeAt(0);
              prevNode = range.startContainer;
              document.getSelection().collapse(prevNode, range.startOffset);
            }
          }, 10);
          self.CANCEL_EVENT({event: e});
          return false;
        }
      }

      if (keyCode == KEYCODES.TAB) {
        // console.log("TAB");
      }
      else if (keyCode == KEYCODES.LEFT && ccs[0][0] <= ccs[0][1]) {
        /* 블럭 처음에서 Left */
        setTimeout(() => {
        ncs = util.getCursorState(self, anchor(), 0);
        if (ccs[0][0] <= ccs[0][1] && ncs[0][0] <= ncs[0][1]) {
          // console.log("GO PREV")
          util.gotoEditorBlock(blockId, 0);
        } }, 1);
      }
      else if (keyCode == KEYCODES.UP && ccs[2][0] <= ccs[2][1]) {
        /* 블럭 첫줄에서 Up */
        setTimeout(() => {
        ncs = util.getCursorState(self, anchor(), 0);
        if (ccs[2][0] <= ccs[2][1] && ncs[2][0] <= ncs[2][1]) {
          // console.log("GO PREV");
          util.gotoEditorBlock(blockId, 0);
        } }, 1);
      }
      else if (keyCode == KEYCODES.RIGHT && ccs[1][0] >= ccs[1][1]) {
        /* 블럭 마지막에서 Right */
        setTimeout(() => {
        ncs = util.getCursorState(self, anchor(), 0);
        if (ccs[1][0] >= ccs[1][1] && ncs[1][0] >= ncs[1][1]) {
          // console.log("GO NEXT")
          util.gotoEditorBlock(blockId, 1);
        } }, 1);
      }
      else if (keyCode == KEYCODES.DOWN && ccs[3][0] >= ccs[3][1]) {
        /* 블럭 마지막줄에서 Down */
        setTimeout(() => {
        ncs = util.getCursorState(self, anchor(), 0);
        if (ccs[3][0] >= ccs[3][1] && ncs[3][0] >= ncs[3][1]) {
          // console.log("GO NEXT");
          util.gotoEditorBlock(blockId, 1);
        } }, 1);
      }
      else if (keyCode == KEYCODES.BS && ccs[0][0] <= ccs[0][1]) {
        /* 블럭 처음에서 Backspace */
        /* 2021-11-15:
         * self.BTPS().TABLE 블럭에서 backspace > 블럭 머징 X
         * self.BTPS().CONTENT 블럭이 최상위 블럭: 의견이 있으면 블럭 삭제 X, 의견이 없으면 블럭 삭제 O >> prtBlock === undefined
         */
        const bspDelBlockFn = function() {
          setTimeout(() => {
          ncs = util.getCursorState(self, anchor(), 0);
          if (ccs[0][0] <= ccs[0][1] && ncs[0][0] <= ncs[0][1]) {
            // console.log ("MERGE PREV");
            util.mergeEditorBlock(blockId, 0);
          } }, 1);
        }

        if (bdata.blockType !== self.BTPS().TABLE) {
          let cmtCnt = null;
          let action = "/api/copaper/opinion/getCmmtCnt";
          let param = {
            paperId: bdata.paperId,
            paperBlockId: blockId,
            deleteYn: "0"
          };
          self.COWORK_REST_ACTION({
            url: action,
            method: "post",
            req: param
          })
            .then(res => { 
              let cmtCnt = res.result;
              if (cmtCnt !== null) {
                let prevBlock = self.getPreviousOrNextBlock(blockId, '-1'); // undefined 일 경우, 현재 블럭이 최상위 블럭

                  if (prevBlock === undefined) { // 최상위 블럭 O: 의견 없을 때만 블럭 삭제
                    if (cmtCnt < 1) {
                      bspDelBlockFn();
                    }
                  }
                  else if (prevBlock !== undefined) { // 최상위 블럭 X: 이전 블럭이 CONTENT가 아니면 의견 없을 때만 블럭 삭제
                    if (prevBlock.bdata.blockType === self.BTPS().CONTENT) {
                      bspDelBlockFn();
                    }
                    else if (prevBlock.bdata.blockType !== self.BTPS().CONTENT && (cmtCnt < 1)) {
                      bspDelBlockFn();
                      // 이전 블럭이 테이블일 경우 포커싱 추가
                      if (prevBlock.bdata.blockType === self.BTPS().TABLE) {
                        let elm = prevBlock.element;
                        this.boardUtil.focusBlock(elm, length, true);
                        setTimeout(() => { elm.caretPosition(length); }, 80);
                      }
                    }
                  }
                }
            })
            .catch(function(err) { console.log(err); });
        }
      }
      else if (keyCode == KEYCODES.DEL && ccs[1][0] >= ccs[1][1]) {
        /* 블럭의 마지막 문단에서 Delete */
        /* 2021-11-15:
         * self.BTPS().TABLE 블럭에서 Delete > 블럭 머징 X
         */
        if (bdata.blockType !== self.BTPS().TABLE) {
          setTimeout(() => {
          ncs = util.getCursorState(self, anchor(), 0);
          if (ccs[1][0] >= ccs[1][1] && ncs[1][0] >= ncs[1][1]) {
            // console.log ("MERGE NEXT");
            util.mergeEditorBlock(blockId, 1);
          } }, 1);
        }
      }
      else if (keyCode == KEYCODES.ENTER) {
        if (prevKeycode !== KEYCODES.ENTER) {
          /* 엔터가 한번 눌린 경우 */
          let clist = self.editor.view.docView.children;
          let cinx = ccs[3][0] - 1;
          let node = clist[cinx] ? clist[cinx].contentDOM : null;
          if (node) {
            /** URL 인경우 링크추가 */
            let urlMatch = util.matchUrl(node.innerText);
            if (urlMatch) {
              let url = urlMatch[0];
              node.parentNode.removeChild(node);
              let input = self.$el.querySelector("div[contenteditable]");
              setTimeout(() => {
                self.TRIGGER_EVENT({element: input, type: EVENT_TYPES.KEYDOWN, attr: { keyCode: KEYCODES.BS }});
              }, 10);
              util.getLinkMeta(url, (success, data, metaTag) => {
                if (success) {
                  util.addNewBlock({
                    blockType: self.BTPS().LINK,
                    contentPath: metaTag.outerHTML,
                    sortNo: self.bdata.sortNo
                  });
                }
                console.log("URL:", url);
              });
            }
          }
          // console.log("NODE:", JSON.stringify(ccs), anchor());
        }
        else {
          if(bdata.blockType !== "TABLE") {
            /** 엔터키가 두번이상 연속으로 들어오는 경우 보정 로직 
             * block 나눈 후 바로 prevKeyCode값 null 처리 
             * skyoon 211022 */
            this.state.prevKeycode = null;
            this.state.splited = true;

            /* 블럭 하단에 [내용 없는] 신규 블럭 생성 함수 */
            const splitBlockLast = function() {
              let view = self.editor.view;
              let contentPrv = "";
              let inx = 0;
              let clist = view.docView.children;
              for (; inx < ccs[3][0] - 1; inx++) {
                contentPrv += clist[inx].contentDOM.outerHTML;
              }
              if (clist[inx] && clist[inx].contentDOM.nodeName != "P") {
                contentPrv += clist[inx].contentDOM.outerHTML;
              }
              contentPrv = contentPrv.replace(/(<p[ ]{0,1}[^>]*>(<br[\/]{0,1}>){0,1}<[\/]p>)/g, "<p></p>");
              {
                let elem = document.createElement("div");
                elem.innerHTML = contentPrv;
                let child = elem.firstChild;
                if (
                  child && 
                  child.nodeName === "P" &&
                  !child.innerText.replace(/[ \t\r\n]/g, "")
                ) {
                  if (child.innerHtml !== undefined) {
                    elem.removeChild(child);
                  }
                  //elem.removeChild(child);
                  contentPrv = elem.innerHTML;
                }
              }
              delete self.bdata.isTemp;
              self.setContent(contentPrv);
              self.html = contentPrv;
              self.updateBlock();
              setTimeout(() => { self.toggleUsageMsg(false); }, 10)
              let index1 = blockIndex + 1;
              let index2 = index1;
              let callback = function(block) {
                util.blurPrevFocusedBlock(block);
                util.focusBlock(block, -1, true);
              };
              util.createTempBlock({ sortNo: bdata.sortNo, content: "" }, callback);
            }

            /* 엔터가 두번 눌린 경우 
             * 블럭 처음에서 엔터 두번: [new blockId] > [현재 blockId] 순으로 위치 - if (self.state.minPosition) {}
             * 블럭 중간에서 엔터 두번: [현재 blockId] > [new blockId] 순으로 위치 - else {}
             * 블럭 마지막에서 엔터 두번: [현재 blockId] > [new blockId] 순으로 위치 - else if (ccs[1][0] >= ccs[1][1] && ccs[1][0]) {}
            */
            if (self.state.minPosition) {
              self.state.minPosition = false;

              let view = self.editor.view;
              let contentPrv = "";
              let inx = 0;
              let clist = view.docView.children;
              for (; inx < ccs[3][0] - 1; inx++) {
                contentPrv += clist[inx].contentDOM.outerHTML;
              }
              let contentCurrnt = view.docView.contentDOM.innerHTML.substring(contentPrv.length);

              if (contentPrv.match(/<img[^>]/g)) {
                // 이미지 태그가 존재할 경우, return
                return ;
              }else {
                // 엔터가 시작된 커서 > 이전 값이 데이터가 있을 때 return
                contentPrv = contentPrv.replace(/(<([^>]+)>)/ig,"");
                if (contentPrv.length > 0) return ;
              }

              {
                /* 엔터로 삽입된 p 태그 삭제 */
                contentCurrnt = contentCurrnt.replace(/^(<p[ ]{0,1}[^>]*>(<br[\/]{0,1}>){0,}<[\/]p>){1}/, "");
                /* 엔터로 삽입된 h2/h3 태그 삭제 */
                contentCurrnt = contentCurrnt.replace(/^(<h\d[ ]{0,1}[^>]*>(<br[\/]{0,1}>){0,}<[\/]h\d>){1}/, "");
                
                if (contentCurrnt) {
                  let elem = document.createElement("div");
                  elem.innerHTML = contentCurrnt;
                  let child = elem.firstChild;

                  if ((child.nodeName === "P" && !child.innerHTML.match(/<img[^>]/g) && !child.innerText.replace(/[ \t\r\n]/g, "")
                      || (contentCurrnt.match(/<img[^>]/g) && !child.innerHTML.match(/<img[^>]/g)))) {
                        // 텍스트 앞에서 엔터 두 번: <p><br /></p> 태그 생성돼서 replace
                        // 붙여넣기 한 이미지 앞에서 엔터 두 번: <p><br /></p> 태그 생성돼서 replace
                    elem.removeChild(child);
                    contentCurrnt = elem.innerHTML;
                  }
                }
              }
              contentCurrnt = contentCurrnt.replace(/(<p[ ]{0,1}[^>]*>(<br[\/]{0,1}>){0,}<[\/]p>)/g, "<p></p>");
              
              if (contentCurrnt.length < 1) {
                // 내용이 없는 블럭에서 enter 2번으로 블럭 분리 시, 하단에 블럭 생성
                splitBlockLast();
                return ;
              }

              delete self.bdata.isTemp;
              self.setContent(contentCurrnt);
              self.html = contentCurrnt;
              /* 2021.12.17 stomp subscribe 정렬 순서 안 맞아서 주석 처리 */
              // self.contentBlockAPI("updateBlock");
              setTimeout(() => { self.toggleUsageMsg(false); }, 10)
              let callback = function(block) {
                util.blurPrevFocusedBlock(block);
                util.focusBlock(block, -1, true);
              };
              util.createTempBlock({ sortNo: (bdata.sortNo - 1), content: "" }, callback);
            }
            else if (ccs[1][0] >= ccs[1][1] && ccs[1][0]) {
              /* !BLOCK SPLIT! 블럭의 마지막 문단에서 엔터 두번 */
              splitBlockLast();
            }
            else {
              /* [빈 블럭: 기존 blockId] > [기존 내용 블럭: new blockId] 순으로 위치 */
              util.splitBlock(self, ccs);
            }
          }
        }
      }
      self.state.target = null;
    },
    focus(forcely = false) {
      this.tracelog("FOCUS-BLOCK", forcely);
      let el = null;
      if (forcely) {
        this.$nextTick(() => {
          el = this.$el.querySelector("div[contenteditable]");
          if (el) {
            this.editor.focus();
          }
        });
      }
      this.boardUtil.ownBlock(this);
    },
    pasted(e) {
      /**
       * IE 에서 클립보드 오류가 있어 tiptap-commands 패치가 필요함
       * (Userland 소스에서 해결할 수 없는 문제)
       * node_modules/tiptap-commands/dist/commands.esm.js 파일 중
       * -- 소스내용 (markPastRule 함수) --
       * function markPastRule (regexp, type, getAttrs) {
       * -- 중략. 약 14줄 아래 --
       * if (parent.type.allowsMarkType(type) && match[1]) {
       * -- 위 소스를 아래와 같이 패치한다 --
       * if (parent && parent.type.allowsMarkType(type) && match[1]) {
       * -- commands.esm.js 파일 첨부 (버젼이 다를수 있으므로 참고용으로 사용)
       * }}}
       */
      let self = this;
      let upFileElement = null; //2021.08.31. 붙여넣기 한 파일만 upload 하기 위한 변수 생성
      let util = self.boardUtil;
      let KEYCODES = self.KEYCODES;
      let EVENT_TYPES = self.EVENT_TYPES;
      let prevHtml = self.html;
      // console.log("E:", e);
      const fncUploadProc = (file, fncImgProc) => {
        // console.log("FILE:", file);
        self.uploadFile(file, self.bdata.sortNo, self.BTPS().IMAGELINK, (paperBlockId) => {
          // console.log("UPLOADED..", file);
          self.CHECK_AND_LAUNCH({check:(ctx) => {
            let t = self.paperBlockMap[paperBlockId];
            return (ctx.ret = (t && (t = t.element) && t.$el) ? t.$el.querySelector("img.noimg") : null)
          }, launch:() => {
            let span = document.createElement("span");
            let img = document.createElement("img");
            span.setAttribute("data-from-block", paperBlockId);
            img.src = "//:0";
            span.appendChild(img);
            if (fncImgProc) { fncImgProc(span); }
            lodash.debounce(() => {
              self.html = self.innerHTML(0);
              self.contentBlockAPI("updateBlock");
            }, 500)();
          }});

          self.CHECK_AND_LAUNCH({check:(ctx) => {
            let t = self.paperBlockMap[paperBlockId];
            return (ctx.ret = (t && (t = t.element) && t.$el) ? !t.state.loading : null)
          }, launch:(ctx) => {
            // console.log("TEST:", ctx.ret);
            self.detectImages(true);
          }});
        });
      };
      // console.log("CLIPBOARD:", e.clipboardData);
      let clipboardStr = "";
      if (e.clipboardData && e.clipboardData.items) {
        for (let item of e.clipboardData.items) {
          // console.log("ITEM:", item ? item.type : "", item);
          // text/plain, text/html, text/rtf 등 클립보드에 값들이 있음.
          // 실질적으로 테이블태그를 가지고있는건 html 이기떄문에 정규식수정 :20230201 조성기
          if (/text\/html/.exec(item.type)) {
            item.getAsString((s) => {
              // console.log("DATA:", s);
              clipboardStr = s;
            });
          }
        }
      }
      if (e.clipboardData && e.clipboardData.items.length == 1) {
        /**
         * clipboardData.items 길이가 2 이상인 경우는 richtext 가 
         * html 혹은 이미지로 렌더링된 데이터가 같이 전송되는 경우이므로
         * 단일타입의 클립보드만 붙여넣기 해야 한다.
         * 예) 엑셀표 붙여넣기시 표html 정보와 함께 이미지도 같이 전송됨
         **/
        // console.log("CLIPBOARD:", e.clipboardData.items.length, e.clipboardData);
        // for (let item of e.clipboardData.items) {
        //   console.log("ITEM:", item);
        //   if (item.type == "text/html") {
        //     item.getAsString((data) => { console.log("DATA:", data); });
        //   }
        // }
        for (let file of e.clipboardData.files) {
          /* IE이외의 브라우저에서는 클립보드 이미지를 따로 처리해 주어야 한다. */
          // console.log("UPLOAD:", file);
          let res = [0];
          let match = file ? /(.+)[.]([a-zA-Z0-9]+$)/.exec(file.name) : ["", "", ""];
          self.HW_KEYGEN({res});
          file.fileName = "i" + res[0] + "." + match[2];
          fncUploadProc(file, (el) => {
            // console.log("APPEND-IMAGE:", el);
            upFileElement = el;
            let range = document.getSelection().getRangeAt(0);
            /* 
              일자    : 2021.08.31.
              작성자  : 윤태진
              사유    : 이미지 복사/붙여넣기 동작 시, 문자열 사이&이미지 사이 붙여넣기 가능하도록 위치 값 조정
            */
            document.getSelection().getRangeAt(0).insertNode(el);
            // range.endContainer.appendChild(el);
             /**
             * 위의 insertNode 후 마우스 caret이 변경되어서 이미지 업로드 후 
             * 문자 입력 시 이미지 사라지는 현상 발생.
             * 이미지 뒤에서 앞쪽으로 드래그 하는 형태가 되어버림.
             * 마우스 caret 위치 추가된 이미지 뒤로 이동처리 
             * skyoon 211022
            */
            el.focus();
            document.getSelection().collapse(el, 1);
          });
        }
      }
      self.$nextTick(() => { setTimeout(() => {
        if (self.blockType() == self.BTPS().CONTENT) {
          let view = self.editor.view;
          let clist = view.docView.children;
          let dlist = [];
          let dinx = 0;
          /* IMG 태그등 선처리 */
          {
            let fncUpdate = lodash.debounce(() => {
              let contentLength = self.$el.querySelector("div[contenteditable]").innerHTML.length
              if (contentLength > 16777215 /* mysql mediumtext 최대길이 */) {
                self.editor.setContent(self.html);
                console.log("PASTE LENGTH OVER:", contentLength);
                self.toast(self.$i18nUtil.trans("message.ContentBlockTypeContent.012","붙여넣기 용량을 초과하였습니다."));
              }
              else {
                self.contentBlockAPI("updateBlock");
              }
            }, 100);
            const fncDomProc = (elem) => {
              if (!elem) { return; }
              if (elem.nodeName == "IMG") {
                if (/src="[\/\/:0]"/g.exec(elem.outerHTML)) { return; }
                /* TODO: 추후 외부 웹페이지 복사시 이미지 BLOB(base64) 처리, src=data:....  */
                let parent = elem.parentNode;
                const regex = /^(data:)[a-zA-Z]+\/([a-zA-Z0-9]+);([a-zA-Z0-9]+),/g;
                let match = regex.exec(elem.src);
                if (match && match[1] == "data:" && match[3] == "base64") {
                  /* IE 에서는 base64 붙여넣기가 되므로 따로 업로드 처리한다 */
                  let contentType = "image/" + match[2];
                  let buffer = [];
                  self.B642BLOB({b64data: elem.src.substring(match[0].length), buffer});
                  let file = new Blob(buffer, {type: contentType});
                  let res = [0];
                  self.HW_KEYGEN({res});
                  file.fileName = "i" + res[0] + "." + match[2];
                  // console.log("UPLOAD:", file);
                  fncUploadProc(file, (el) => {
                    parent.insertBefore(el, elem);
                    parent.removeChild(elem);
                    fncUpdate();
                  });
                }
                else {
                  // console.log("IMG:", img.src, img);
                  self.IMG_TO_BLOB({img:elem, blobProc(blob) {
                    const regex = /^[a-zA-Z]+\/([a-zA-Z0-9]+)$/g;
                    let match = regex.exec(blob.type);
                    if (match && match[1]) {
                      let res = [0];
                      self.HW_KEYGEN({res});
                      blob.fileName = "i" + res[0] +"." + match[1];
                      // console.log("UPLOAD:", blob, match, elem);
                      fncUploadProc(blob, (el) => {
                        parent.insertBefore(el, elem);
                        parent.removeChild(elem);
                        fncUpdate();
                      });
                    }
                  }});
                }
              }
              // console.log("HTML:", elem.innerHTML);
              let children = elem.childNodes;
              if (!children) { return; }
              for (let child of children) {
                if(child.outerHTML !== "<img src=\"//:0\">"){
                  fncDomProc(child); 
                }
              }
            };
            fncDomProc(upFileElement);
            // console.log("VIEW:", view.docView.dom.innerHTML);
            // for (let cinx = 0; cinx < clist.length; cinx++) {
            //   fncDomProc(clist[cinx].contentDOM);
            // }
            /**
             * _{{내용}}_ 인 경우 강제로 <em> 태그로 전환되는 현상 수정
             * Tiptap 편집기 기능으로 '_' 로 둘러쌓인 텍스트는 자동으로 <em> 태그가 붙는현상
             * 강제로 수정, Ctrl+Z 키이벤트 전송하고 커서 위치에 강제로 내용 주입.
             **/
            /* 
              일자 : 2021.07.21. 작성자 : 윤태진. 사유 : [ _문자열_ ] 붙여넣기시 기능 해제
            */
            // if (/[_][^_]+[_]/.exec(clipboardStr)) {
            //   let elem = document.createElement("div");
            //   elem.innerHTML = prevHtml;
            //   // console.log("TEXT:", elem.innerText);
            //   if (util.trim(elem.innerText).length == 0) {
            //     // console.log("CLEAR!");
            //     self.setContent("");
            //   } else {
            //     self.TRIGGER_EVENT({element: e.target,
            //       type: EVENT_TYPES.KEYDOWN, attr: {
            //         bubbles:true, keyCode: KEYCODES.KBZ, ctrlKey: true }});
            //   }
            //   setTimeout(() => {
            //     let selection = document.getSelection();
            //     let range = selection ? selection.getRangeAt(0) : null;
            //     if (range) {
            //       let element = range.startContainer;
            //       let sibling = element.nextSibling;
            //       let parent = element.parentNode;
            //       // console.log("START[" + element.nodeName + "]:",
            //       //   element, range.startOffset, range);
            //       if (element.nodeName == "#text") {
            //         let text = element.nodeValue;
            //         let prev = text.substring(0, range.startOffset);
            //         let next = text.substring(range.startOffset);
            //         element.nodeValue = prev;
            //         let nextNode = document.createTextNode(next);
            //         let newNode = document.createElement("div");
            //         newNode.innerHTML = clipboardStr;
            //         // console.log("SIBLING:", sibling, nextNode);
            //         if (sibling) {
            //           for (let node of newNode.childNodes) { parent.insertBefore(node, sibling); }
            //           parent.insertBefore(nextNode, sibling);
            //         } else {
            //           for (let node of newNode.childNodes) { parent.appendChild(node); }
            //           parent.appendChild(nextNode);
            //         }
            //         document.getSelection().collapse(nextNode, 0);
            //       } else {
            //         parent = element;
            //         element = parent.childNodes[range.startOffset];
            //         sibling = element ? element.nextSibling : false;
            //         let newNode = document.createElement("div");
            //         newNode.innerHTML = clipboardStr;
            //         // console.log("ELEMENT:", element, sibling, parent, parent.length, newNode);
            //         if (range.startOffset == 0) {
            //           for (let node of newNode.childNodes) { parent.insertBefore(node, element); }
            //           parent.insertBefore(newNode, element);
            //           document.getSelection().collapse(element, 0);
            //         } else {
            //           let focusNode = element;
            //           if (sibling) {
            //             for (let node of newNode.childNodes) { parent.insertBefore(node, element); }
            //             focusNode = element;
            //           } else {
            //             for (let node of newNode.childNodes) { parent.appendChild(node); }
            //             let children = parent.childNodes;
            //             focusNode = children[children.length - 1];
            //           }
            //           let children = parent.childNodes;
            //           let lastNode = children[children.length - 1];
            //           if (focusNode.nodeName == "#text") {
            //             document.getSelection().collapse(focusNode, focusNode.nodeValue.length);
            //           } else {
            //             document.getSelection().collapse(focusNode, 1);
            //           }
            //         }
            //       }
            //     }
            //     self.html = self.innerHTML(1);
            //   }, 1);
            // }
          }
          setTimeout(() => {
            for (let cinx = 0; cinx < clist.length; cinx++) {
              let citem = clist[cinx] ? clist[cinx].contentDOM : {};
              /* 붙여넣은 블럭에서 표가 발견되면 */
              if (citem.nodeName == "TBODY") {
                let tableHTML = citem.outerHTML;
                if (!self.state.isIE[0]) {
                  /** 
                   * 클립보드 테이블(엑셀붙여넣기)에서 칼럼 색상추출.
                   * 강제입력하는 부분 IE 이외의 브라우저에서 실행
                   **/
                  let div = document.createElement("div");
                  div.innerHTML = clipboardStr;
                  let styleText = div.querySelector("style").innerText;
                  styleText = styleText.replace(/^[\r\n\t ]*<!--/g, "");
                  styleText = styleText.replace(/-->[\r\n\t ]*$/g, "");
                  let style = { };
                  while (true) {
                    /*{*/
                    let ptn = /([.]xl[0-9]+)[\r\n\t ]+[{]([^}]+)[}]/g; 
                    let mat = ptn.exec(styleText);
                    if (!mat) { break; }
                    // console.log("MAT:", mat[2]);
                    styleText = styleText.substring(mat.index + mat[0].length);
                    style[mat[1]] = mat[2].replace(/[\r\n\t ]+/g, " ");
                  }
                  // console.log("STYLE:", style);
                  // console.log("TABLE:", div.querySelector("table"));
                  for (let cls in style) {
                    let list = div.querySelectorAll(cls);
                    for (let td of list) {
                      let s = td.getAttribute("style");
                      // style 값이 없을 때 null로 들어가서 style 값이 나오지 않고있음.
                      // s를 그대로 넣어주는게아닌 "" 빈값으로 수정. :20230201 조성기
                      td.setAttribute("style", (s ? s + ";" : "") + style[cls]);
                    }
                  }
                  tableHTML = div.querySelector("table").innerHTML;
                }
                dlist[++dinx] = "<div><table>" + tableHTML + "</table></div>";
                dinx++;
              }
              else {
                dlist[dinx] = (dlist[dinx] || "") + citem.outerHTML;
              }
            }
            if (dlist.length > 1) {
              /* 테이블이 발견된 경우 dlist 는 2개 이상이며, dlist 길이 - 1 만큼 블럭이 추가된다. */
              // console.log("DATA:", dlist);
              self.html = dlist[0];
              self.editor.setContent(self.html);

              if (self.state.isIE[0]) {
                setTimeout(() => { self.contentBlockAPI("updateBlock"); }, 10)
              }else{
                setTimeout(() => { self.contentBlockAPI("updateBlock");}, 100);
              }
              
              for (let dinx = 1, sortNo = self.bdata.sortNo; dinx < dlist.length; dinx++, sortNo++) {
                // let ditem = dlist[dinx];
                let ditem = this.pinBlockCheck(dlist[dinx],true);
                let btype = (dinx % 2) ? self.BTPS().TABLE : self.BTPS().CONTENT;
                util.addNewBlock({
                  blockType: btype,
                  contentPath: ditem,
                  sortNo: sortNo
                });
              }
            }
            if (self.$refs.menubar && self.$refs.menubar.$el) {
              /* 메뉴바 숨김 class hidden 으로 처리되지 않아 직접처리 */
              self.$refs.menubar.$el.style.display = "none";
            }
          }, 200);
        }
      }, 500) });
      delete self.bdata.isTemp;
      setTimeout(self.setEnableEditable, 1000);
    },
    editorDrop(e) {
      /* 같은 문서내 드래그 & 본문드랍 이 발생할 경우 취소! */
      if (e.srcElement.ownerDocument == document) {
        this.editor.setContent(this.html);
      }
    },
    caretPosition(pos, keys = false) {
      this.tracelog("CARET-POSITION");
      let KEYCODES = this.KEYCODES;
      let EVENT_TYPES = this.EVENT_TYPES;
      this.editor.setSelection(pos, pos);
      let el = this.$el.querySelector("div[contenteditable]");
      if (keys) {
        for (let inx = 0; inx < keys.length; inx++) {
          this.TRIGGER_EVENT({element: el, type: EVENT_TYPES.KEYDOWN, attr: { keyCode: keys[inx] }});
        }
      }
      else {
        this.TRIGGER_EVENT({element: el, type: EVENT_TYPES.KEYDOWN, attr: { keyCode: KEYCODES.ENTER }});
        this.TRIGGER_EVENT({element: el, type: EVENT_TYPES.KEYDOWN, attr: { keyCode: KEYCODES.BS }});
        this.TRIGGER_EVENT({element: el, type: EVENT_TYPES.KEYDOWN, attr: { keyCode: KEYCODES.DEL }});
      }
    },
    blur() {
      this.editor.blur();

      /* 멘션기능 사용자목록 감추기 */
      let members = document.getElementById("board-members-selector");
      if (!members.classList.contains("hidden")) { 
        if (members.onHidden) {
          members.onHidden();
        }
        else {
          members.classList.add("hidden");
        }
      }
    },
    checkLockOwn(bdata) {
      if (!bdata) {
        bdata = this.bdata;
      }
      let ret = this.OTPS().NOBODY;
      if (bdata.blockLockYn === 1) {
        if (bdata.blockLockId === this.userInfo.userId) {
          ret = this.OTPS().OWNER;
        }
        else if (!bdata.blockLockId) {
          /* Lock Timeout! */
        }
        else {
          ret = this.OTPS().ANOTHER;
        }
      }
      return ret;
    },
    cancelBlur(fnc, arg) {
      this.tracelog("CANCEL-BLUR");
      if (this.state.handleSubmit) {
        clearTimeout(this.state.handleSubmit);
      }
      this.state.handleSubmit = -1;
      this.$nextTick(() => {
        this.editor.view.dom.focus();
      });
      if (fnc && arg) {
        fnc(arg);
      }
      else if (fnc) {
        fnc();
        // 테이블 메뉴에서 실행된 command에 대해 updateBlock 수행
        // tiptap 변경사항이 HTML DOM에 적용될때 까지 100ms 대기 후 수행
        setTimeout(() => {
          this.contentBlockAPI("updateBlock");
        }, 100);
      }
      else {
        setTimeout(() => {
          this.contentBlockAPI("updateBlock");
        }, 100);
      }
    },
    cancelBlurBranch(editorFnc, blockFnc) {
      this.tracelog("CANCEL-BLUR-BRANCH");
      if (this.state.handleSubmit) {
        clearTimeout(this.state.handleSubmit);
      }
      this.state.handleSubmit = -1;
      this.$nextTick(() => {
        this.editor.view.dom.focus();
      });
      let blockType = this.blockType();
      if (blockType === this.BTPS().CONTENT) {
        editorFnc();
        setTimeout(() => {
          this.contentBlockAPI("updateBlock");
        }, 100);
      } else {
        blockFnc()
      }
    },
    resizeTable(refreshCol) {
      // let elem = this.$el.querySelector(".editor-wrapper table");
      // if (!elem) { return; }
      // let colWidths = [];
      // let bw = this.$el.offsetWidth;
      // let tw = elem.offsetWidth;
      // this.boardUtil.getTableColumnWidths(elem, colWidths);
      // this.boardUtil.updateTableColumnWidths(elem, colWidths, bw, tw);
    },
    resizeContent() {
      let $el = this.$el;
      let parent = $el.parentNode;
      let editor = $el.querySelector("div[contenteditable]");
      let table = $el.querySelector("table");
      if (table && parent) {
        let wrapper = $el.querySelector(".editor-wrapper");
        wrapper.classList.add("cell-resize");
        wrapper.style.width = parent.offsetWidth + "px";
        wrapper.style.position = "relative";
        wrapper.style.overflowX = "auto";
        editor.style.width = table.offsetWidth + "px";
      }
    },
    detectImages(changeImage = false) {
      let self = this;
      let $ctn = self.$el.querySelector("div[contenteditable]");
      let images = $ctn ? $ctn.querySelectorAll("span[data-from-block]>img") : [];
      for (let image of images) {
        // console.log("IMAGE:", image, blockId);
        let blockId = image.parentNode.getAttribute("data-from-block");
        self.CHECK_AND_LAUNCH({check(ctx) {
          ctx.block = self.paperBlockMap[blockId];
          return ctx.block && ctx.block.bdata && ctx.block.bdata.fileId;
        }, launch(ctx) {

          // console.log("LINK-IMAGE:", image, ctx.block);
          self.HW_LOAD_IMAGE({img:image, groupId:self.paperInfo.groupId,
            paperId:self.paperInfo.paperId, fileId:ctx.block.bdata.fileId,
            callback(status) {
              if(status){
                if (changeImage) {
                  let parent = image.parentNode;
                  let newImg = document.createElement("img");
                  newImg.src = image.src;
                  parent.insertBefore(newImg, image);
                  parent.removeChild(image);
                }
              }
              self.$emit("blockMatch");
            }});
        }});
      }
    },
    onEditorContentRendered() {
      let self = this;
      let height = self.$el.offsetHeight;
      if (height && self.$refs.dragHandle) {
        let style = self.$refs.dragHandle.style;
        style.top = "0px";
        style.height = height * 1 + 20 + "px";
      }
      else {
        setTimeout(this.onEditorContentRendered, 500);
      }
      if (this.blockType() === this.BTPS().TABLE) {
        // this.resizeTable(true);
      }
    },
    innerText(domexp = false) {
      let el = this.$refs.editor;
      let text = this.bdata.contentPath;
      const fncExplorer = (elem) => {
        let text = "";
        if (!elem) { return ""; }
        let parent = elem.parentNode;
        let children = elem.childNodes;
        if (children && children.length > 0) {
          for (let child of children) {
            text += fncExplorer(child);
          }
        }
        else if (elem.nodeName == "IMG") {
          text += "[IMG]";
        }
        else if (elem.nodeName == "#text") {
          text += elem.nodeValue;
        }
        if (elem.nodeName == "LI" &&
          (parent.nodeName == "UL" || parent.nodeName == "OL")) {
          text = "." + text;
        }
        return text;
      };
      if (el && el.$el) {
        el = el.$el.querySelector("div[contenteditable]");
        if (el) {
          if (domexp) {
            text = fncExplorer(el);
          }
          else {
            text = el.innerText;
          }
        }
      }
      text = text.replace(/^[  \t\r\n\0]+/, "");
      text = text.replace(/[  \t\r\n\0]+$/, "");
      text = text.replace(/^[\r\n]{0,1}$/g,"");
      return text;
    },
    innerHTML(normType) {
      let fncProcess = (node, normType) => {
        let tmp = null;
        let parent = node.parentNode;
        if (node.childElementCount == 1 &&
          node.nodeName == "DIV" && 
          node.classList.contains("tableWrapper") &&
          node.querySelector("table")) {
            let child = node.firstChild;
            node.removeChild(child);
            parent.insertBefore(child, node);
            parent.removeChild(node);
            node = child;
        }
        if (node.nodeName == "TABLE" && (tmp = node.querySelector("colgroup"))) {
          node.removeChild(tmp);
        }
        if (node.classList) {
          node.classList.remove("has-focus");
        }
        return node;
      };
      let fncNavigate = (node, normType) => {
        if ((node = node.firstChild)) {
          node = fncProcess(node, normType);
          fncNavigate(node, normType);
          for (; (node = node.nextSibling);) {
            node = fncProcess(node, normType);
            fncNavigate(node, normType);
          }
        }
      };
      let html = this.editor.getHTML();
      if (normType != 0) {
        let element = document.createElement("div");
        element.innerHTML = html;
        fncNavigate(element, normType);
        html = element.innerHTML; 
      }
      return html;
    },
    opinionCreate() {
      /* 의사결정 위젯을 띄운다 */
      let el = this.$refs.opinionForm;
      el.classList.toggle("hidden");
      console.log("show opinion create form");
    },
    showColorPicker(show, type) {
      let self = this;
      let button = type === null ? self.$refs.colorPickerBtn : self.$refs.tableColorPickerBtn;
      let colorPicker = type === null ? self.$refs.colorPickerBdy : self.$refs.tableColorPickerBdy;
      if (show) {
        if (colorPicker.eventHandle) {
          clearTimeout(colorPicker.eventHandle);
        }
        colorPicker.classList.remove("hidden");
        colorPicker.style.left = button.offsetLeft + "px";
        setTimeout(self.cancelBlur, 500);
      }
      else {
        colorPicker.eventHandle = setTimeout(() => {
          colorPicker.classList.add("hidden");
        }, 300);
      }
    },
    setColorFromPicker(e, color, commands, type) {
      let self = this;
      let colorPicker = type === null ? self.$refs.colorPickerBdy : self.$refs.tableColorPickerBdy;
      colorPicker.classList.add("hidden");
      if (type === null) { // 텍스트 색상
        if (color == "#000000") { color = "none"; }
        commands.span_element({ color: color });
      }else { // 테이블 셀 색상: type === 'TABLE' === tableBubbleMenu
        if (color == "#b8814c") { color = "#fff"; }
        commands.tableBackgroundColor({name: 'background', value: color})
      }
      setTimeout(() => {
        self.html = self.innerHTML(1);
        self.cancelBlur();
        //self.setDisableEditable();
        self.contentBlockAPI("updateBlock");
      }, 500);
      self.CANCEL_EVENT({event: e});
    },
    editorType() {
      return true;
    },
    focusable() {
      let ret = false;
      let lockYn = this.bdata.blockLockYn;
      let lockId = this.bdata.blockLockId;

      if (lockYn === 1 && lockId === this.userInfo.userId) {
        ret = true;
      }
      else if (lockYn != 1) {
        ret = true;
      }
      return ret;
    },
    isSetColor(color) {
      const regex = /[;]{0,1}\s*color\s*[:]\s*((rgb\s*\([0-9, ]+\))|([#][a-fA-F0-9]+)|([a-zA-Z0-9]+))\s*[;]{0,1}/ig;
      let selection = document.getSelection();
      if (selection && selection.rangeCount > 0) {
        let range = selection.getRangeAt(0);
        let elem = false;
        if (range && (elem = range.startContainer) && 
          (elem = elem.parentNode) && elem.nodeName == "SPAN") {
          let mat = regex.exec(elem.getAttribute("style"));
          if (mat && mat[1] == color) {
            return true;
          }
        }
      }
      return false;
    },
    markStyle({isActive, commands, param}) {
      let self = this;
      if (["bold", "italic", "strike", "underline"].indexOf(param) != -1) {
        commands[param]();
        setTimeout(() => { self.contentBlockAPI("updateBlock"); }, 100)
      }
    },
    paraHeading({isActive, commands, tag}) {
      let self = this;
      let range = document.getSelection().getRangeAt(0);
      if (range && range.startContainer) {
        let para = range.startContainer;
        if (para.parentNode != self.$el.querySelector("div[contentEditable]")) {
          para = para.parentNode;
        }
        let align = "left";
        if (isActive.paragraph({ textAlign: "center" })) { align = "center"; }
        else if (isActive.paragraph({ textAlign: "right" })) { align = "right"; }
        commands.paragraph({ tag, textAlign: align });
        setTimeout(() => { self.contentBlockAPI("updateBlock"); }, 100)
      }
    },
    paraAlign({isActive, commands, align}) {
      let self = this;
      let range = document.getSelection().getRangeAt(0);
      if (range && range.startContainer) {
        let para = range.startContainer;
        if (para.parentNode != self.$el.querySelector("div[contentEditable]")) {
          // para = para.parentNode;

          /* 2021-11-05 표에서 연속으로 align 설정 시, 화면 깨지는 현상 조치 */
          let prtNode = para.parentNode.nodeName.toLowerCase();
          para = prtNode !== 'th' && prtNode !== 'td' ? para.parentNode : para;
        }
        commands.paragraph({ tag:para.nodeName.toLowerCase(), textAlign: align });
        setTimeout(() => { self.contentBlockAPI("updateBlock"); }, 100)
      }
    },
    getPreviousOrNextBlock(blockId, calc) {
      let idx = 0;
      for (let i=0; i<this.paperBlockIdList.length; i++) {
        let blockListId = this.paperBlockIdList[i];
        if (blockListId === blockId) { idx = i; break; }
      }
      return this.paperBlockMap[this.paperBlockIdList[idx + (calc * 1)]];
    },
    checkEmptyBlock(){
      let self = this;
      if(self.bdata.blockType == self.BTPS().CONTENT){

        let textarea = self.bdata.contentPath;
        let textarea1 = textarea.replace(/^[  \t\r\n\0]+/gi, "");
        let textarea2 = textarea1.replace(/[  \t\r\n\0]+$/gi, "");
        let textarea3 = textarea2.replace(/<(\/)?([a-zA-Z1-9]*)(\s[a-zA-Z1-9]*=[^>]*)?(\s)*(\/)?>/g,"");
        // console.log(textarea+" :: "+textarea1 +" :: "+ textarea2 +" :: "+ textarea3);

        if(textarea3 == ""){
          self.emptyBlock = true;
        }else{
          self.emptyBlock = false;
        }
      }else{
        self.emptyBlock = false;
      }
      return self.emptyBlock;
    },
    /* 에디터 클릭 시,
     * 내가 점유한 블럭이면서 테이블일 때, 표 버블 메뉴 SHOW / HIDE 위해 이벤트 전달 
     */
    clickEditor(editor) {
      if (this.checkLockOwn() === this.OTPS().OWNER && editor.isActive.table() && editor.focused) {
        this.$emit("focusTable", true, this.paperBlockId, editor.commands);
      }else {
        this.$emit("focusTable", false, null, null);
      }
    },
    pinBlockCheck(htmlData,returnYn){
      /*
       * 표블럭 복사붙여넣기시(엑셀) 개인정보차단 로직을 돌지않아 추가.
       * htmlData / type 의 내용이 들어있을떄 해당 내용으로 체크 / 값 리턴 해줌.
       * htmlData / type 의 내용이 없을 때 this.html 내용으로 체크 리턴값 없음. 바로 변경로직수행.
      */
      if(localStorage.getItem("pinBlockYn") == "true"){
        let match = null;
        //주민등록번호 (20년 10월 신규 출생자 패턴)
        // let regex1 = /((?<=\D)|^|\b)((20((1[02])(0[1-9]|[12][0-9]|3[01])|(11)(0[1-9]|[12][0-9]|3[0])))|((2[1-9]|3[0-9])((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01])|(0[469]|11)(0[1-9]|[12][0-9]|3[0])|(02)(0[1-9]|[12][0-9]))))(-?| )([34]\d{6})((?=\D)|$|\b)/g;
        let regex1 = /((20((1[02])(0[1-9]|[12][0-9]|3[01])|(11)(0[1-9]|[12][0-9]|3[0])))|((2[1-9]|3[0-9])((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01])|(0[469]|11)(0[1-9]|[12][0-9]|3[0])|(02)(0[1-9]|[12][0-9]))))(-?| )([34]\d{6})/g;
        //주민등록번호 (기존 주민등록번호 변경 신청자)
        // let regex2 =/((?<=\D)|^|\b)(((\d{2}((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01])|(0[469]|11)(0[1-9]|[12][0-9]|3[0])|(02)(0[1-9]|[12][0-9])))(-?| )([12]\d{6}))|((((20)((0[13578])(0[1-9]|[12][0-9]|3[01])|(0[469])(0[1-9]|[12][0-9]|3[0])|(02)(0[1-9]|[12][0-9])))|(([01][0-9])((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01])|(0[469]|11)(0[1-9]|[12][0-9]|3[0])|(02)(0[1-9]|[12][0-9]))))(-?| )([34]\d{6})))((?=\D)|$|\b)/g;
        let regex2 =/(((\d{2}((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01])|(0[469]|11)(0[1-9]|[12][0-9]|3[0])|(02)(0[1-9]|[12][0-9])))(-?| )([12]\d{6}))|((((20)((0[13578])(0[1-9]|[12][0-9]|3[01])|(0[469])(0[1-9]|[12][0-9]|3[0])|(02)(0[1-9]|[12][0-9])))|(([01][0-9])((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01])|(0[469]|11)(0[1-9]|[12][0-9]|3[0])|(02)(0[1-9]|[12][0-9]))))(-?| )([34]\d{6})))/g;
        // 외국인등록번호
        // let regex3 =/((?<=\D)|^|\b)(((2[1-9]|[3-9][0-9])((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01])|(0[469]|11)(0[1-9]|[12][0-9]|3[0])|(02)(0[1-9]|[12][0-9]))(-?| )([5-6]\d{6}))|(\d{2}((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01])|(0[469]|11)(0[1-9]|[12][0-9]|3[0])|(02)(0[1-9]|[12][0-9]))(-?| )([7-8]\d{6})))((?=\D)|$|\b)/g;
        let regex3 =/(((2[1-9]|[3-9][0-9])((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01])|(0[469]|11)(0[1-9]|[12][0-9]|3[0])|(02)(0[1-9]|[12][0-9]))(-?| )([5-6]\d{6}))|(\d{2}((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01])|(0[469]|11)(0[1-9]|[12][0-9]|3[0])|(02)(0[1-9]|[12][0-9]))(-?| )([7-8]\d{6})))/g;
        // 전자여권번호
        // let regex4 =/(\b)[Mm]\d{8}((?=\D)|$|\b)/g;
        let regex4 =/[mMsSrRgGdD]\d{8}/g;
        // 신운전면허번호
        // let regex5 =/((?<=[^a-zA-Z0-9`~!@#$%^&*()-=_+|\\])|^)((1[1-9]|2[0-6])-\d{2}-\d{6}-\d{2}|(1[1-9]|2[0-6]) \d{2}-\d{6}-\d{2}|(1[1-9]|2[0-6]) \d{2} \d{6} \d{2})((?=[^a-zA-Z0-9`~!@#$%^&*()-=_+|\\])|$)/g;
        let regex5 =/((1[1-9]|2[0-6])-\d{2}-\d{6}-\d{2}|(1[1-9]|2[0-6]) \d{2}-\d{6}-\d{2}|(1[1-9]|2[0-6]) \d{2} \d{6} \d{2})/g;
        
        // 호출등 태그안에 있는 id 값들이 검색이되기 때문에 태그 제거후 검색
        // console.log(this.html);
        if(htmlData == null && htmlData == undefined){
          htmlData = this.html;
        }
        if(htmlData != null && htmlData !== undefined){
          let tempHtml = htmlData;
          let tempHtml1 = tempHtml.replace(/^[  \t\r\n\0]+/gi, "");
          let tempHtml2 = tempHtml1.replace(/[  \t\r\n\0]+$/gi, "");
          let tempHtml3 = tempHtml2.replace(/<(\/)?([a-zA-Z1-9]*)(\s[a-zA-Z1-9-]*=[^>]*)?(\s)*(\/)?>/g,"");

          let result1 = regex1.exec(tempHtml3); 
          let result2 = regex2.exec(tempHtml3); 
          let result3 = regex3.exec(tempHtml3); 
          let result4 = regex4.exec(tempHtml3); 
          let result5 = regex5.exec(tempHtml3); 
          if (result1 != null) {
            match = result1;
          }else if(result2 != null){
            match = result2;
          }else if(result3 != null){
            match = result3;
          }else if(result4 != null){
            match = result4;
          }else if(result5 != null){
            match = result5;
          } 
          //  console.log(match);
        }
        let tableCursorSate = this.editor.state.selection.$anchor.pos;
        if(match != null && htmlData.indexOf(match[0]) != -1){  
          let textarea = htmlData;
          let textarea1 = textarea.replace(/^[  \t\r\n\0]+/gi, "");
          let textarea2 = textarea1.replace(/[  \t\r\n\0]+$/gi, "");
          let textarea3 = textarea2.replace(/<(\/)?([a-zA-Z1-9]*)(\s[a-zA-Z1-9]*=[^>]*)?(\s)*(\/)?>/g,"");
          let matchText = match[0]; 
          if(returnYn){
            return htmlData.replace(matchText,"");
          }else{
            let location = textarea3.indexOf(matchText); 
            this.html = htmlData.replace(matchText,"");
            this.setContent(this.html); 
            setTimeout(() => {
              if(this.bdata.blockType == "TABLE"){ 
                this.caretPosition(tableCursorSate - matchText.length); 
              }else{
                this.caretPosition(location+1);
              }
            }, 200);
          }
        } else{
          if(returnYn){
            return htmlData;
          }
        }
      } else{
        if(returnYn){
          return htmlData;
        }
      }

    }
  },
};
</script>
<!-- 지역스타일 지정 -->
<style scoped>

.board_layout.box-click .editor .name {
  position: relative;
  top: -8px;
}
.board_layout.box-click .editor .lock {
  top: 13px;
}
.align_top > .hover_box .move, .align_top > .hover_box .hover_comment {
  top: 0px;
}
.board_layout.box-click .eidtbox-ty1::after {
  height: calc(100% - 5px);
  top: 2px;
}
.board_txt.message {
  position: absolute;
  font-size: 14px;
}
.menububble.is-active {
    display: inline-flex;
    min-width: 370px;
}
</style>



// WEBPACK FOOTER //
// src/components/cowork/general/board/editor/ContentBlockTypeContent.vue